const translations = {};

translations["MSG_GUIDE"] = "ガイド";
translations["MSG_NETWORK_ERROR_MESSAGE"] =
  "ページを表示することができませんでした。\nもう一度試してみてください。";
translations["MSG_APP_ALL"] = "すべて";
translations["MSG_APP_BANNER_TITLE"] = "アプリ版『まなんでパズル』";
translations["MSG_APP_BANNER_SUBTITLE"] = "～子供も楽しくプログラミング教育～";
translations["MSG_APP_BANNER_INSTALL_BTN"] = "インストール";
translations["MSG_APP_BANNER_SHOW_BTN"] = "表示";

translations["MSG_APP_VERSION_UPDATE_WARNING_TITLE"] = "アプリを最新版にアップデートします。";
translations["MSG_APP_VERSION_UPDATE_WARNING_MESSAGE"] =
  "最新版のアプリがあります。\n最新の機能を利用する為にアップデートが必要です。\nアップデートはすぐに完了します。";
translations["MSG_APP_ERROR_PASSWORD_TOO_SHORT"] = "6文字以上のパスワードを入力してください。";
translations["MSG_APP_ERROR_PASSWORD_CONFIRM_NOT_VALID"] = "パスワードが一致していません。";
translations["MSG_SIGN_IN_BTN"] = "ログイン";
translations["MSG_SIGN_UP_BTN"] = "新規登録";
translations["MSG_SIGN_IN_WITH_APPLE"] = "Appleで続ける";
translations["MSG_SIGN_UP_WITH_APPLE"] = "Appleで続ける";
translations["MSG_SIGN_IN_WITH_GOOGLE"] = "Googleで続ける";
translations["MSG_SIGN_IN_WITH_MAIL"] = "メールでログイン";
translations["MSG_SIGN_UP_WITH_MAIL"] = "メールで登録する";
translations["MSG_SIGN_NO_ACCOUNT_REGISTER"] = "アカウントがない方は新規登録";
translations["MSG_SIGN_ALREADY_ACCOUNT_LOGIN"] = "既にアカウントがある方はログイン";
translations["MSG_SIGN_PASSWORD_REQUIRED"] = "パスワードを入力してください";
translations["MSG_SIGN_LOGIN_FAILED"] =
  "ログインに失敗しました。メールアドレスとパスワードを確認してください。";
translations["MSG_SIGN_PASSWORD_MISMATCH"] = "パスワードが一致しません";
translations["MSG_SIGN_UP_FAILED"] = "アカウント作成に失敗しました。もう一度お試しください。";
translations["MSG_SIGN_EMAIL_REQUIRED"] = "メールアドレスを入力してください";
translations["MSG_SIGN_EMAIL_INVALID"] = "有効なメールアドレスを入力してください";
translations["MSG_SIGN_PASSWORD_RESET_FAILED"] =
  "パスワードリセットメールの送信に失敗しました。もう一度お試しください。";
translations["MSG_SIGN_PASSWORD_RESET_DESCRIPTION"] =
  "※登録したメールアドレスにパスワードリセット用のリンクを送信します。";
translations["MSG_SIGN_PASSWORD_RESET_SEND_BTN"] = "リセットメール送信";
translations["MSG_SIGN_EMAIL_SENT"] = "メールを送信しました";
translations["MSG_SIGN_PASSWORD_RESET_SENT"] =
  "パスワードリセット用のリンクを送信しました。\nメールをご確認ください。";
translations["MSG_SIGN_BACK_TO_LOGIN"] = "ログイン画面に戻る";
translations["MSG_USER_NAME_LENGTH_LIMIT"] = "名前は10文字以内で入力してください";
translations["MSG_USER_NAME_REQUIRED"] = "名前を入力してください";
translations["MSG_USER_LATEST"] = "最新";
translations["MSG_USER_LIST"] = "プレイヤー一覧";
translations["MSG_USER_START_LEARNING_MESSAGE"] =
  "お子様が学習を始めるために、\nまずはアカウントを作成してください。";
translations["MSG_USER_ADD_CHILD_ACCOUNT"] = "お子様のアカウントを追加";
translations["MSG_USER_START"] = "スタート";
translations["MSG_SIGN_USER_MAIL"] = "メールアドレス";
translations["MSG_SIGN_USER_PASSWORD"] = "パスワード";
translations["MSG_SIGN_USER_PASSWORD_CONFIRM"] = "パスワード再入力";
translations["MSG_SIGN_IN_SUCCESS_CONTENT"] = "ログイン成功しました。";
translations["MSG_SIGN_UP_SUCCESS_CONTENT"] = "アカウント登録成功しました。";
translations["MSG_REAUTH_TITLE"] = "本人確認";
translations["MSG_REAUTH_SSO_MESSAGE"] = "続けるにはもう一度ログインしてください";
translations["MSG_REAUTH_PASSWORD_RESET_CONFIRM"] =
  "パスワードリセットメールを以下のアドレスに送信します";
translations["MSG_REAUTH_BACK"] = "戻る";
translations["MSG_BTN_LATER"] = "あとで";
translations["MSG_BTN_CLOSE"] = "閉じる";

// Restricted Feature Dialog (統合版)
translations["MSG_RESTRICTED_FEATURE_TITLE_COURSE"] = "コースを遊べません";
translations["MSG_RESTRICTED_FEATURE_TITLE_PROJECT_LIMIT"] = "アプリを作れません";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_PROJECT_LIMIT"] =
  "「%{plan}」ではアプリは%{limit}個まで作れます。\nほかのプランを選ぶともっと作れます。<br>保護者に相談してください。";
translations["MSG_RESTRICTED_FEATURE_TITLE_CHILD_USER_LIMIT"] = "プレイヤーを追加できません";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_CHILD_USER_LIMIT"] =
  "「%{plan}」ではプレイヤーは%{limit}名まで<br>追加できます。\nほかのプランを選ぶともっと追加できます。<br>保護者に相談してください。";
translations["MSG_RESTRICTED_FEATURE_TITLE_AI_CHAT_LIMIT"] = "メッセージを送れません";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_AI_CHAT_LIMIT"] =
  "「%{plan}」では1日%{limit}回まで送れます。\nほかのプランを選ぶともっと送れます。<br>保護者に相談してください。";
translations["MSG_RESTRICTED_FEATURE_TITLE_AI_IMAGE_LIMIT"] = "画像を作れません";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_AI_IMAGE_LIMIT"] =
  "「%{plan}」では1日%{limit}回まで作れます。\nほかのプランを選ぶともっと作れます。<br>保護者に相談してください。";
translations["MSG_RESTRICTED_FEATURE_TITLE_ASSET_LIMIT"] = "素材を保存できません";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_ASSET_LIMIT"] =
  "「%{plan}」では素材は%{limit}まで保存できます。\nほかのプランを選ぶともっと保存できます。<br>保護者に相談してください。";
translations["MSG_RESTRICTED_FEATURE_BTN_VIEW_PLANS"] = "プランを選ぶ";

// Upgrade Promotion
translations["MSG_UPGRADE_PROMOTION_TITLE"] = "プランを変更して、もっと楽しもう！";
translations["MSG_UPGRADE_MODAL_TITLE"] = "プランを選ぶ";
translations["MSG_UPGRADE_MODAL_SUBTITLE"] = "お子様の利用状況に合ったプランをご検討ください";
translations["MSG_UPGRADE_MODAL_CURRENT_PLAN"] = "現在のプラン";
translations["MSG_UPGRADE_PROMOTION_RECOMMENDED"] = "おすすめ";
translations["MSG_UPGRADE_PROMOTION_TABLE_PLAN"] = "プラン";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS"] = "プレイヤー数";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS_TRIAL"] = "1人";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS_FREE"] = "2人";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS_STANDARD"] = "4人";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS_PREMIUM"] = "8人";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS"] = "作品数";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS_TRIAL"] = "1個";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS_FREE"] = "5個";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS_STANDARD"] = "10個";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS_PREMIUM"] = "10個";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE"] = "AI画像";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE_TRIAL"] = "1日1回";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE_FREE"] = "1日2回";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE_STANDARD"] = "1日10回";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE_PREMIUM"] = "無制限\n（同時3枚）";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT"] = "まなパルくん";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT_TRIAL"] = "1日4回";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT_FREE"] = "1日8回";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT_STANDARD"] = "無制限";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT_PREMIUM"] = "無制限";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE"] = "データの保存容量";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE_TRIAL"] = "100MB";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE_FREE"] = "1GB";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE_STANDARD"] = "5GB";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE_PREMIUM"] = "50GB";
translations["MSG_PLAN_CHANGE_BTN"] = "プラン変更";
translations["MSG_UPGRADE_PROMOTION_CHANGE_BTN"] = "変更";
translations["MSG_UPGRADE_PROMOTION_TRIAL_DESCRIPTION"] =
  "アカウント登録すると、課金プランに申し込めます";
translations["MSG_UPGRADE_PROMOTION_FREE_DESCRIPTION"] = "保護者ページでプランを変更できます";
translations["MSG_UPGRADE_PROMOTION_LATER_BTN"] = "あとで";
translations["MSG_UPGRADE_PROMOTION_SIGNUP_BTN"] = "アカウント登録";
translations["MSG_UPGRADE_PROMOTION_UPGRADE_BTN"] = "保護者ページへ";
translations["MSG_UPGRADE_PROMOTION_BTN_REGISTER"] = "登録";
translations["MSG_UPGRADE_PROMOTION_BTN_PURCHASE"] = "購入";

translations["MSG_SIGN_IN_FAILED_TITLE"] = "ログイン失敗";
translations["MSG_SIGN_IN_FAILED_MESSAGE"] = "メールアドレスかパスワードが間違っています。";
translations["MSG_SIGN_IN_FORGOT_PASSWORD"] = "パスワードを忘れた場合";
translations["MSG_SIGN_IN_FORGOT_PASSWORD_TITLE"] = "パスワードリセット";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_CURRENT_PASSWORD"] = "現在のパスワード";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_NEW_PASSWORD"] = "新しいパスワード";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_NEW_PASSWORD_CONFIRM"] = "パスワードを確認";
translations["MSG_SIGN_IN_CHANGE_PASSWORD_SUCCESS_CONTENT"] = "パスワード変更成功しました。";
translations["MSG_SIGN_IN_CHANGE_PASSWORD_CURRENT_PASSWORD_WRONG"] =
  "入力したパスワードが間違っています。";
translations["MSG_SIGN_UP_EMAIL_ALREADY_EXISTS_FAILED_MESSAGE"] =
  "このメールアドレスは既に利用されます。";
translations["MSG_PARENTS_PROFILE_DEFAULT_NAME"] = "保護者";

translations["MSG_DATETIME_PERIOD"] = "期間";
translations["MSG_DATETIME_PERIOD_RECENTLY"] = "最近";
translations["MSG_DATETIME_FORMAT_HOUR"] = "時";
translations["MSG_DATETIME_FORMAT_MINUTE"] = "分";

translations["MSG_INEXUS_OFFICIAL"] = "まなんでパズル";
translations["MSG_INEXUS_OFFICIAL_CONTACT"] = "まなパズサポート";
translations["MSG_AI_CHAT_SESSION_START"] = "新しい会話";
translations["MSG_AI_CHAT_SESSION_END"] = "会話おわり";
translations["MSG_REVIEW_RATING_TITLE"] = "『まなんでパズル』の\n評価を\n教えてください！";
translations["MSG_REVIEW_FEEDBACK_TITLE"] = "ごいけんばこ";
translations["MSG_REVIEW_SEND_RATING_CONFIRM"] = "送る";
translations["MSG_REVIEW_SEND_FEEDBACK_CONFIRM"] = "ご意見を送る";
translations["MSG_REVIEW_THANKS_BUBBLE_TEXT"] = "ありがとう\nございました！";
translations["MSG_REVIEW_FEEDBACK_THANKS_TEXT"] =
  "これからも、『まなんでパズル』を\nよろしくおねがいします。";

translations["MSG_REVIEW_FEEDBACK_TYPE_APP"] = "アプリ全体";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE"] = "『コースでまなぶ』";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR"] = "『じゆうにつくる』";
translations["MSG_REVIEW_FEEDBACK_TYPE_NONE"] = "不満はない";
translations["MSG_REVIEW_FEEDBACK_TYPE_APP_HOW_TO_USE"] = "使い方が\nわからない";
translations["MSG_REVIEW_FEEDBACK_TYPE_APP_HARD_TO_USE"] = "使いづらい";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_DIFFICULT"] = "難しすぎる";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_EASY"] = "簡単すぎる";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_MANY"] = "ステージが\n多すぎる";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_FEW"] = "ステージが\n少なすぎる";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR_HARD_TO_CREATE"] = "うまく\n作れない";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR_HARD_TO_USE"] = "使い方が\n難しい";
translations["MSG_REVIEW_FEEDBACK_PLACEHOLDER"] = "ここに自由に書いてください";
translations["MSG_USER_PROFILE_CHANGE_USER"] = "プレイヤー切り替え";
translations["MSG_USER_PROFILE_CHANGE_USER_TITLE"] = "プレイヤーを切り替えますか？";
translations["MSG_USER_PROFILE_CHANGE_USER_MESSAGE"] = "「%{name}」に切り替えます。";
translations["MSG_USER_PROFILE_CHANGE_USER_SUCCESS"] = "プレイヤーを切り替えました。";
translations["MSG_USER_PROFILE_CHANGE_USER_FAILED"] = "プレイヤーの切り替えに失敗しました。";
translations["MSG_USER_PROFILE_MAX_USER_TITLE"] = "プレイヤーを追加できません";
translations["MSG_USER_PROFILE_MAX_USER_MESSAGE"] =
  "今使っているプランではプレイヤーを%{limit}人まで作れます\n新しいプレイヤーを作るにはいらないプレイヤーを消してください";
translations["MSG_USER_PROFILE_ADD_USER_DISABLED_TITLE"] = "ここでは追加できないよ";
translations["MSG_USER_PROFILE_ADD_USER_DISABLED_MESSAGE"] =
  "・プレイヤーの追加は、保護者の方だけが行うことができます。\n・プレイヤーを追加する場合は、保護者の方に保護者ページから追加して貰ってください。";
translations["MSG_USER_PROFILE_SHOW_USER_LIST_BTN"] = "もっと";
translations["MSG_USER_PROFILE_USER_STATUS"] = "ステータス";
translations["MSG_USER_SELECTION_PROMPT"] = "プレイヤーを選んでね";
translations["MSG_USER_PROFILE_DEFAULT_NAME"] = "名前%{random}";
translations["MSG_USER_PROFILE_INPUT_NAME_PROMPT"] = "名前をつけてね";
translations["MSG_USER_PROFILE_FIELD_NAME"] = "ニックネーム";
translations["MSG_USER_PROFILE_FIELD_NAME_PLACEHOLDER"] = "ニックネームを入れてください";
translations["MSG_USER_PROFILE_FIELD_GENDER"] = "性別";
translations["MSG_USER_PROFILE_FIELD_GENDER_MALE"] = "男性";
translations["MSG_USER_PROFILE_FIELD_GENDER_FEMALE"] = "女性";
translations["MSG_USER_PROFILE_FIELD_GENDER_NONE"] = "なし";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY"] = "誕生日";
translations["MSG_USER_PROFILE_STATUS_COURSE_CLEARED"] = "クリアした\nコース";
translations["MSG_USER_PROFILE_STATUS_PROJECTS"] = "作った\nアプリ";
translations["MSG_USER_PROFILE_STATUS_PUBLISHED_PROJECTS"] = "公開した\nアプリ";
translations["MSG_USER_PROFILE_STATUS_PROJECT_RECEIVED_FAVORITE"] = "もらった\nいいねの数";
translations["MSG_USER_PROFILE_STATUS_DAYS_SINCE_JOIN"] = "はじめて\nから";
translations["MSG_USER_PROFILE_STATUS_DAYS_UNIT"] = "%{count}日";
translations["MSG_USER_PROFILE_STATUS_PLAN"] = "プラン";
translations["MSG_USER_TAB_PROGRESS"] = "学習";
translations["MSG_USER_TAB_STOCK"] = "持ち物";
translations["MSG_USER_TAB_PLAN"] = "プラン";
translations["MSG_USER_PLAN_CURRENT"] = "利用中";
translations["MSG_USER_PLAN_USAGE"] = "使っている量";
translations["MSG_USER_PLAN_CHANGE"] = "プランを変える";
translations["MSG_USER_PLAN_PROJECTS"] = "作品の数";
translations["MSG_USER_PLAN_AI_CHAT"] = "まなパルくん";
translations["MSG_USER_PLAN_AI_IMAGE"] = "画像を作る";
translations["MSG_USER_PLAN_UNLIMITED"] = "無制限";
translations["MSG_USER_PLAN_HERO_INCLUDED"] = "含まれているもの";
translations["MSG_USER_PLAN_HERO_TAGLINE_TRIAL"] = "試してみよう！";
translations["MSG_USER_PLAN_HERO_TAGLINE_FREE"] = "無料で遊ぼう";
translations["MSG_USER_PLAN_HERO_TAGLINE_STANDARD"] = "もっとたくさん作れる";
translations["MSG_USER_PLAN_HERO_TAGLINE_PREMIUM"] = "なんでも作れる！";
translations["MSG_USER_PLAN_HERO_TAGLINE_BUILDER"] = "マップも作れる！";
translations["MSG_USER_PLAN_HERO_TAGLINE_EDUCATION"] = "みんなで学ぼう";
translations["MSG_USER_PLAN_UPGRADE_CARD_TITLE"] = "もっと遊べるプランもあるよ";
translations["MSG_USER_PLAN_UPGRADE_COMPARE_HEADER_NOW"] = "今";
translations["MSG_USER_PLAN_UPGRADE_COMPARE_HEADER_NEXT"] = "アップグレード後";
translations["MSG_USER_PLAN_BILLING_MONTHLY"] = "月ごと";
translations["MSG_USER_PLAN_BILLING_ANNUAL"] = "年ごと";
translations["MSG_USER_PLAN_BILLING_ANNUAL_DEAL"] = "2ヶ月分お得！";
translations["MSG_USER_PLAN_BILLING_ANNUAL_DEAL_BADGE"] = "2ヶ月お得！";
translations["MSG_USER_PLAN_PRICE_PER_MONTH"] = "/月";
translations["MSG_USER_PLAN_PRICE_PER_YEAR"] = "/年";
translations["MSG_USER_PLAN_UPGRADE_BTN"] = "今すぐアップグレード";
translations["MSG_USER_PLAN_VIEW_ALL_PLANS"] = "すべてのプランを見る";
translations["MSG_USER_PLAN_UPDATE_REQUIRED_TITLE"] = "アプリを最新にしてね";
translations["MSG_USER_PLAN_UPDATE_REQUIRED_MESSAGE"] = "最新バージョンにアップデートしてね";
translations["MSG_USER_PLAN_PURCHASE_SUCCESS"] = "アップグレードできたよ！";
translations["MSG_USER_PLAN_PURCHASE_ERROR"] = "うまくいかなかったよ。もう一度試してね";
translations["MSG_USER_PLAN_AI_IMAGE_PER_REQUEST"] = "1回で";
translations["MSG_USER_PLAN_AI_IMAGE_CREATE_COUNT"] = "作成回数";
translations["MSG_USER_PLAN_AI_IMAGE_SIMULTANEOUS_COUNT"] = "同時枚数";
translations["MSG_USER_PLAN_ASSETS"] = "ストレージ";
translations["MSG_USER_PLAN_SUBTAB_CURRENT"] = "利用\n状況";
translations["MSG_USER_PLAN_SUBTAB_PURCHASE"] = "プランを\n購入";
translations["MSG_USER_PLAN_COMPARE_HEADER_CURRENT"] = "今";
translations["MSG_USER_PLAN_INACTIVE_NOTICE"] = "全部の機能が使えるよ！";
translations["MSG_USER_PLAN_CARD_CURRENT_BADGE"] = "今のプラン";
translations["MSG_USER_PLAN_PRICE_FREE"] = "¥0";
translations["MSG_USER_PLAN_GOTO_PURCHASE"] = "プランをアップグレード";
translations["MSG_USER_PLAN_BUY_BTN"] = "このプランにする";
translations["MSG_USER_PLAN_REGISTER_BTN"] = "登録";
translations["MSG_USER_PLAN_COMPARE_SAME"] = "同じ";
translations["MSG_USER_PLAN_COMPARE_UNLOCK"] = "使えるよ！";
translations["MSG_USER_PLAN_TIMES_SUFFIX"] = "倍";
translations["MSG_USER_PLAN_USAGE_CARD_TITLE"] = "利用状況";
translations["MSG_USER_PLAN_USAGE_CARD_SUBTITLE"] = "今日の利用状況";
translations["MSG_USER_PLAN_UPGRADE_PREVIEW_TITLE"] = "アップグレードすると";
translations["MSG_USER_PLAN_UPGRADE_PREVIEW_SUBTITLE"] = "できることがぐーんと増えるよ！";
translations["MSG_USER_PLAN_UNIT_PIECES"] = "個";
translations["MSG_USER_PLAN_UNIT_TIMES"] = "回";
translations["MSG_USER_PLAN_UNIT_SHEETS"] = "枚";
translations["MSG_USER_PLAN_PERIOD_DAILY"] = "日";
translations["MSG_USER_PROFILE_PROGRESS"] = "記録";
translations["MSG_USER_PROFILE_PROGRESS_NEW_TITLE"] = "New!";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_LEVEL_TITLE"] = "レベル";
translations["MSG_USER_PROFILE_PROGRESS_COURSE"] = "コースで\nまなぶ";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_CLEARED_BTN"] = "クリアした\nコース";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_CHART_DATE_TITLE"] = "日目";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_CLEARED_TITLE"] = "クリアした数";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR"] = "じゆうに\nつくる";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_BTN"] = "自分の\n作品";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_VIEW_TITLE_START"] = "合計";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_VIEW_TITLE_END"] = "人";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_FAVORITED_TITLE_START"] = "合計";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_FAVORITED_TITLE_END"] = "いいね";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_VIEWED_TITLE"] = "見に来た人";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_FAVORITED_TITLE"] = "いいねの数";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_EMPTY"] = "まだ作品がありません";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_EMPTY_DESC"] =
  "「じゆうにつくる」で遊ぶと、ここに並びます";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_GOTO_BTN"] = "『じゆうにつくる』へ";
translations["MSG_USER_PROFILE_INFO"] = "自分";
translations["MSG_USER_PROFILE_ICON_BTN"] = "アイコンを変更";
translations["MSG_USER_PROFILE_CASE_BTN"] = "ケースを変更";
translations["MSG_USER_PROFILE_STOCK"] = "素材";
translations["MSG_USER_PROFILE_SETTING"] = "設定";
translations["MSG_USER_PROFILE_ADD_USER_BTN"] = "追加";
translations["MSG_USER_PROFILE_NAME_ERROR_TITLE"] = "登録ができませんでした。";
translations["MSG_USER_PROFILE_NAME_ERROR_MESSAGE"] =
  "使う事のできない文字や文章が含まれています。もう一度やり直してください。";
translations["MSG_PARENTS_USER_PROFILE_NAME_ERROR_TITLE"] = "登録ができませんでした。";
translations["MSG_PARENTS_USER_PROFILE_NAME_ERROR_MESSAGE"] =
  "使う事のできない文字や文章が含まれています。もう一度やり直してください。";
translations["MSG_USER_PROFILE_MESSAGE"] = "郵便";
translations["MSG_USER_PROFILE_MESSAGE_CONTACT_TITLE"] = "%{type}のお問い合わせ";
translations["MSG_USER_PROFILE_MESSAGE_CONTACT_INPUT_AUTO_REPLY"] =
  "お問合せありがとうございます！\n下の入力枠にお問合せの内容を書いてください。";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_INPUT_AUTO_REPLY"] =
  translations["MSG_USER_PROFILE_MESSAGE_CONTACT_INPUT_AUTO_REPLY"];
translations["MSG_USER_PROFILE_MESSAGE_PARENTS_TALK_WELCOME_TEXT"] = "が参加しました。";
translations["MSG_USER_PROFILE_MESSAGE_CHAT_SEND_BTN"] = "送る";
translations["MSG_USER_PROFILE_MESSAGE_MENU"] = "メニュー";

translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_0"] =
  "%{name}さん、『まなんでパズル』へ ようこそ！";
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_1"] =
  "『まなんでパズル』では、パズルのように 楽しく 遊びながら プログラミングを 勉強できます。\nまずは、順番に 遊び方や 勉強の方法を 覚えるために、『コースでまなぶ』から始めて みてください！";
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_2"] =
  "アルゴリズムやプログラムの やりかたが だいたい分かったところで、『じゆうにつくる』で、自分の思うままに アプリを作ってみてください。";
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_3"] =
  "さぁ、『まなんでパズル』を レッツトライ！";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_RATING"] = "の評価を送りました。";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_RATING_AUTO_REPLY"] = "評価ありがとうございました！";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_AUTO_REPLY"] =
  "ご意見ありがとうございました！";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_TITLE"] = "ご意見";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_TYPE_OTHER"] = "・そのた：";
translations["MSG_USER_PROFILE_MESSAGE_CHAT_PLACEHOLDER"] = "ここに自由に書いてください";
translations["MSG_USER_PROFILE_MESSAGE_PUBLISHED_PROJECT_MESSAGE"] =
  "アプリ「%{name}」を公開しました。";

translations["MSG_USER_DASHBOARD_TITLE"] = "ダッシュボード";
translations["MSG_USER_DASHBOARD_VIEW_FULL_PAGE"] = "マイページ\n開く";
translations["MSG_USER_DASHBOARD_UNREAD"] = "未読";
translations["MSG_USER_DASHBOARD_NO_UNREAD"] = "新しいメッセージはないよ";
translations["MSG_DASHBOARD_SWITCH_PLAYER"] = "プレイヤー\n切り替え";
translations["MSG_DASHBOARD_ADD_PLAYER"] = "プレイヤー\n追加";
translations["MSG_DASHBOARD_CHANGE_PLAN"] = "プラン\n変更";
translations["MSG_DASHBOARD_PLAN_USAGE_TITLE"] = "ご利用状況";
translations["MSG_DASHBOARD_QUICK_SETTINGS_TITLE"] = "クイック設定";
translations["MSG_DASHBOARD_SETTING_LANGUAGE"] = "言語";
translations["MSG_DASHBOARD_PLAN_USAGE_AI_CHAT"] = "AIチャット";
translations["MSG_DASHBOARD_PLAN_USAGE_AI_IMAGE"] = "AI画像";
translations["MSG_DASHBOARD_PLAN_USAGE_PROJECTS"] = "作品";
translations["MSG_DASHBOARD_PLAN_USAGE_STORAGE"] = "ストレージ";

translations["MSG_TOP_TUTORIAL_FIRST_WELCOME_MESSAGE"] =
  "はじめてのひとは\nチュートリアルを\nみてね！";
translations["MSG_TOP_TUTORIAL_WELCOME_MESSAGE_1"] = "きょうもいっしょに\nがんばろう！";
translations["MSG_TOP_TUTORIAL_WELCOME_MESSAGE_2"] = "たのしくパズルで\nまなぼうね！";
translations["MSG_TOP_TUTORIAL_WELCOME_MESSAGE_3"] =
  "ぼくといっしょに\nプログラミングを\nまなぼう！";
translations["MSG_TOP_TUTORIAL_APP_START"] = "はじめる";
translations["MSG_TOP_TUTORIAL_START"] = "チュートリアルをみる";
translations["MSG_TOP_TUTORIAL_DONOT_SHOW"] = "次回から表示しない";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_1"] = "「まなんでパズル」\nについて";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_2"] = "「コースでまなぶ」\nについて";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_3"] = "「じゆうにつくる」\nについて";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_4"] = "ヘルプボタンと\nマイページ";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_5"] = "保護者の方用の\nメニューについて";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_6"] = "アプリの設定を\n行う";
translations["MSG_TOP_TUTORIAL_CLOSE_PAGE"] = "この画面を閉じる";
translations["MSG_TOP_TUTORIAL_NEXT_PAGE"] = "次へ";
translations["MSG_TOP_TUTORIAL_START_APP"] = "『まなんでパズル』を始める";
translations["MSG_ONBOARDING_PARENT_START"] = "パズルをスタート";
translations["MSG_ONBOARDING_PARENT_START_SUB"] =
  "新規利用は保護者登録が必要です\nデータを引き継いで遊びたい方もこちら";
translations["MSG_ONBOARDING_SELF_START"] = "お試しではじめる";
translations["MSG_ONBOARDING_SELF_START_SUB"] = "登録なしで体験できます";

translations["MSG_AUTH_SELECTION_INSTRUCTION"] =
  "アカウントをお持ちの方は「ログイン」、初めての方は「新規登録」をお選びください。";
translations["MSG_AUTH_SIGN_IN"] = "ログイン";
translations["MSG_AUTH_SIGN_IN_DESC"] = "既存のアカウントでログイン";
translations["MSG_AUTH_SIGN_UP"] = "新規登録";
translations["MSG_AUTH_SIGN_UP_DESC"] = "新しいアカウントを作成";
translations["MSG_NOTIFICATION_DEFAULT_TITLE"] = "お知らせ";

translations["MSG_TRIAL_NOTICE_TITLE"] = "おためしの期間が終わります！";
translations["MSG_TRIAL_NOTICE_BODY"] =
  "保護者登録すると、もっと遊べる・もっと作れるようになります。";
translations["MSG_TRIAL_NOTICE_FOR_KIDS"] = "つづけるには、保護者を登録してください。";
translations["MSG_TRIAL_NOTICE_NOTE_FREE"] = "保護者登録は無料です。";
translations["MSG_TRIAL_NOTICE_CTA"] = "みまもり設定";
translations["MSG_PARENT_REGISTRATION_PROMPT_CTA_HINT"] =
  "つづけるには、「みまもり設定」を してください。";
translations["MSG_PARENT_REGISTRATION_PROMPT_CTA"] = "みまもり設定";
translations["MSG_GUEST_PURCHASE_OVERLAY_HINT"] = "「みまもり設定」をしてください";

translations["MSG_BACK_BTN"] = "もどる";
translations["MSG_HOME_BTN"] = "ホーム";
translations["MSG_CLOSE_BTN"] = "とじる";
translations["MSG_CANCEL_BTN"] = "キャンセル";
translations["MSG_NEXT_BTN"] = "次へ";
translations["MSG_GENERATE_BTN"] = "生成";
translations["MSG_CONFIRM_BTN"] = "決定";
translations["MSG_SAVE_BTN"] = "保存";
translations["MSG_STOP_BTN"] = "やめる";
translations["MSG_DELETE_BTN"] = "削除する";
translations["MSG_PARENTS_CANCEL_BTN"] = "キャンセル";
translations["MSG_PARENTS_CONFIRM_BTN"] = "決定";
translations["MSG_PARENTS_DELETE_BTN"] = "削除";
translations["MSG_ERROR_RELOAD_BTN"] = "やりなおす";
translations["MSG_ERROR_TITLE"] = "正しく処理を完了することができませんでした。";
translations["MSG_ERROR_MESSAGE"] =
  "もう一度やり直してください。\nやり直してもこの画面が出る場合は、保護者の人に相談してください。";
translations["MSG_TOAST_FAILED"] = "失敗しました";
translations["MSG_TOAST_SEND_FAILED"] = "送信失敗しました";
translations["MSG_TOAST_EDIT_SUCCESS"] = "変更しました";
translations["MSG_TOAST_DELETED_SUCCESS"] = "削除しました";
translations["MSG_TOAST_PUBLISHED_SUCCESS"] = "公開しました";
translations["MSG_TOAST_DISABLE_PUBLISHED_SUCCESS"] = "公開をやめました";
translations["MSG_TOAST_ENABLE_COPIED_SUCCESS"] = "コピーを許可しました";
translations["MSG_TOAST_DISABLE_COPIED_SUCCESS"] = "コピーを許可しないにしました";
translations["MSG_TOAST_RESTORE_SUCCESS"] = "アプリを戻しました";
translations["MSG_TOAST_COPY"] = "コピーしました。";
translations["MSG_TOAST_PAST"] = "ペーストしました。";
translations["MSG_TOAST_UNDO"] = "元に戻しました。";
translations["MSG_TOAST_REDO"] = "やり直しました。";
translations["MSG_TOAST_INSERT_ASSET_IMAGE_SUCCESS"] = "画像を追加しました。";
translations["MSG_TOAST_INSERT_ASSET_TEMPLATE_SUCCESS"] = "テンプレートを追加しました。";
translations["MSG_TOAST_CONTACT_SEND"] = "お問い合わせ内容を送信しました";
translations["MSG_SETTING_TOP_TUTORIAL"] = "アプリの起動画面";
translations["MSG_SETTING_TOP_TUTORIAL_SHOW"] = "最初に表示";
translations["MSG_SETTING_TOP_TUTORIAL_NOT_SHOW"] = "表示しない";
translations["MSG_SETTING_APP_LANGUAGE"] = "アプリの表示言語";
translations["MSG_SETTING_SOUND"] = "効果音";
translations["MSG_SETTING_BGM"] = "音楽";
translations["MSG_SETTING_PARENT_GATE"] = "みまもり設定";
translations["MSG_SETTING_GO_TO_TOP"] = "トップページ";
translations["MSG_SETTING_GO_TO_CONTACT"] = "お問い合せ";
translations["MSG_SETTING_GO_TO_REVIEW"] = "アプリの評価";
translations["MSG_SETTING_GO_TO_ASSISTANT"] = "まなパルくんと会話";
translations["MSG_ASSISTANT_NAME"] = "まなパルくん";
translations["MSG_ASSISTANT_STATUS"] = "会話できるよ！";
translations["MSG_ASSISTANT_YOU"] = "あなた";
translations["MSG_ASSISTANT_PLACEHOLDER"] = "メッセージを入れてね...";
translations["MSG_ASSISTANT_SEND"] = "送る";
translations["MSG_ASSISTANT_STOP"] = "止める";
translations["MSG_ASSISTANT_GREETING"] =
  "%{name}くん、こんにちは！\nまなパルくんだよ。\n何か質問ある？";
translations["MSG_ASSISTANT_USAGE_COUNT"] = "今日 %{remaining}/%{limit}回";
translations["MSG_ASSISTANT_EDUCATION_UNAVAILABLE"] = "教室プランではまなパルくんと会話できないよ";
translations["MSG_ASSISTANT_PARENT_NOT_ALLOWED"] = "おうちの人が許可していないよ";
translations["MSG_ASSISTANT_SELECT_IMAGE"] = "写真を選ぶ";
translations["MSG_ASSISTANT_TAB_ALBUM"] = "アルバム";
translations["MSG_ASSISTANT_TAB_DRAWING"] = "お絵かき";
translations["MSG_ASSISTANT_TAB_AI"] = "AIが作った絵";
translations["MSG_ASSISTANT_STAMP_TAB"] = "スタンプ";
translations["MSG_ASSISTANT_LIMIT_REACHED"] = "今日の会話は終わり！また明日ね！";
translations["MSG_ASSISTANT_NEW_CHAT"] = "新しい会話";
translations["MSG_ASSISTANT_UPGRADE_BTN"] = "回数を増やす";
translations["MSG_ASSISTANT_AI_ERROR"] =
  "今 お返事ができなかったよ。少し待ってからもう一度試してね！";
translations["MSG_ASSISTANT_NEW_CHAT_CONFIRM_TITLE"] = "最初からスタート！";
translations["MSG_ASSISTANT_NEW_CHAT_CONFIRM_MESSAGE"] =
  "会話を最初からやり直し\n違う話題でOKだよ\nいつでも気軽にスタートできるよ";
translations["MSG_ASSISTANT_NEW_CHAT_CONFIRM_BTN"] = "会話のスタート";
translations["MSG_SETTING_CLOSE_BTN"] = "この画面を閉じる";
translations["MSG_SETTING_TITLE_COURSE_ANSWER"] = "コースの解答を見る";
translations["MSG_SETTING_TITLE_CORPORATE_AUTH"] = "企業連携認証";
translations["MSG_SETTING_FOOTER_GO_TO_SITE"] = "『まなんでパズル』のサイトへ";
translations["MSG_SETTING_FOOTER_TERMS_OF_SERVICE"] = "ご利用規約";
translations["MSG_SETTING_FOOTER_PRIVACY_POLICY"] = "プライバシーポリシー";
translations["MSG_SETTING_FOOTER_INQUIRY"] = "お問い合わせ";
translations["MSG_SETTING_PARENTS_ENABLE_KIDS_USER_TITLE"] = "プレイを再開します";
translations["MSG_SETTING_PARENTS_ENABLE_KIDS_USER_MESSAGE"] =
  "このプレイヤーのプレイを再開します。";
translations["MSG_SETTING_PARENTS_DISABLE_KIDS_USER_TITLE"] = "プレイを中止します";
translations["MSG_SETTING_PARENTS_DISABLE_KIDS_USER_MESSAGE"] =
  "このプレイヤーのプレイを中止します。";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MAX_WARNING_TITLE"] = "有効化できません";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MAX_WARNING_MESSAGE"] =
  "有効化できるプレイヤーの数は最大４人までです。\nこのプレイヤーを有効化する場合には、ほかの不要なプレイヤーを無効化（もしくは削除）を行なってください。";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MIN_WARNING_TITLE"] = "変更できません";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MIN_WARNING_MESSAGE"] =
  "最低でも１名のプレイヤーが必要です。\nこれ以上プレイヤーを減らすことはできません。";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_ACTIVE_WARNING_TITLE"] = "変更できません";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_ACTIVE_WARNING_MESSAGE"] =
  "ログイン中のプレイヤーは停止できません。\n別のプレイヤーに切り替えてから、このプレイヤーを停止してください。";
translations["MSG_SETTING_PARENTS_USER_SIGN_OUT_TITLE"] = "ログアウトします";
translations["MSG_SETTING_PARENTS_USER_SIGN_OUT_MESSAGE"] =
  "・アカウントをログアウトすると、今お使いのプレイヤーで遊ぶことができなくなります。\n・プレイヤーの情報はアカウントに保存されますので、また同じプレイヤーで遊びたい場合は、このアカウントで再度ログインを行ってください。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_WARNING_TITLE"] = "【重要】ご注意ください";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_WARNING_MESSAGE"] =
  "『まなんでパズル』からアカウント削除すると、下記のデータの全てが削除されます。\n・登録したプロフィール情報やアカウント情報。\n・登録した全員分のプレイヤー情報。\n・プレイヤーが作成した「じゆうにつくる」のアプリ。\n・プレイヤーがクリアした「コースでまなぶ」の全ての成績やクリア実績。\n・プレイヤーが行ってきた「トーク履歴」等。\n※ 【重要】ログインしているアカウントの削除を行うと、本アカウントに関連するすべてのデータ削除されますので、十分にご注意ください。\n※ 【重要】この作業はいかなる場合も復旧することはできません。アカウントを削除する場合は十分にご注意ください。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_FORM_TITLE"] =
  "アカウント削除の理由を教えてください。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_TITLE"] = "本当にアカウント削除しますか？";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_MESSAGE"] =
  "アカウント削除するとアカウント・プレイヤーを含むすべてのデータが削除されます。\nアカウント削除処理は復旧することができません。ご注意ください。";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_ALREADY_ERROR_TITLE"] =
  "連携ができません";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_ALREADY_ERROR_MESSAGE"] =
  "ソーシャルアカウントはすでに別のアカウントと連携しました。";
translations["MSG_SETTING_PARENTS_USER_KIDS_PROFILE_CREATED_AT"] = "登録日";
translations["MSG_SETTING_PARENTS_USER_PROFILE_LATEST_AT"] = "最後ログイン日";
translations["MSG_SETTING_PARENTS_USER_PROFILE_UNSUBSCRIBE_BTN"] = "アカウント削除";
translations["MSG_SETTING_PARENTS_USER_PROFILE_DISPLAY_NAME_LIMIT"] =
  "%{limit}文字以内で入力してください。";

translations["MSG_SETTING_COURSE_ANSWER_COURSE_TITLE"] = "コースを選ぶ";
translations["MSG_SETTING_COURSE_ANSWER_STAGE_TITLE"] = "ステージを選ぶ";
translations["MSG_SETTING_COURSE_ANSWER_LEVEL_TITLE"] = "レベルを選ぶ";
translations["MSG_SETTING_COURSE_ANSWER_STAGE"] = "ステージ";
translations["MSG_SETTING_COURSE_ANSWER_LEVEL"] = "レベル";
translations["MSG_SETTING_PARENTS_LINK_ADD_USER_AUTH_CODE_TITLE"] = "認証コード";

translations["MSG_CONTACT_TITLE"] = "おといあわせ";
translations["MSG_CONTACT_TYPE_TITLE"] = "お問い合わせの種類を選んでください";
translations["MSG_CONTACT_DETAIL_TITLE"] = "お問い合わせの内容を詳しく教えてください";
translations["MSG_CONTACT_TYPE_HOW_TO"] = "使い方が\nわからない";
translations["MSG_CONTACT_TYPE_BUG"] = "うまく\n動かない";
translations["MSG_CONTACT_TYPE_REQUEST"] = "追加して\nほしい機能";
translations["MSG_CONTACT_TYPE_OTHER"] = "その他の\n質問";
translations["MSG_CONTACT_SEND_BTN"] = "お問い合わせを送る";
translations["MSG_SETTING_SHAKE_BUG_REPORT"] = "振って知らせる";
translations["MSG_SHAKE_BUG_REPORT_TITLE"] = "うまく動かない？";
translations["MSG_SHAKE_BUG_REPORT_DESCRIPTION"] =
  "今の画面を写真に撮りました。\nお問い合わせで教えてください。";
translations["MSG_SHAKE_BUG_REPORT_CAPTURE_LABEL"] = "今の画面";
translations["MSG_SHAKE_BUG_REPORT_BTN"] = "教える";
translations["MSG_SHAKE_BUG_REPORT_TOGGLE_LABEL"] = "振って知らせる";
translations["MSG_SHAKE_BUG_REPORT_TOGGLE_DESCRIPTION"] =
  "オフにすると、振ってもこの画面は出ません。";
translations["MSG_CONTACT_CAPTURE_LABEL"] = "送る画面";
translations["MSG_CONTACT_CAPTURE_EMPTY"] = "画面は送りません";
translations["MSG_CHAT_CAPTURE_SCREEN_BTN"] = "画面を撮る";
translations["MSG_CHAT_ATTACHED_IMAGE_LABEL"] = "送る画像";
translations["MSG_CONTACT_CAPTURE_REMOVE_BTN"] = "外す";

translations["MSG_PARENT_GATE_WARNING"] =
  "このページは\nおとなのひとに\nかくにんして\nもらってくださいね";
translations["MSG_PARENT_GATE_TITLE"] = "保護者の方へ";
translations["MSG_PARENT_GATE_DESCRIPTION"] =
  "この先は、保護者の方向けの設定、アカウント情報ページとなります。\n以下の画像を指示のとおりタップしてから、進むボタンを押してください。";
translations["MSG_PARENT_GATE_CLOSE_BTN"] = translations["MSG_SETTING_CLOSE_BTN"];
translations["MSG_PARENT_GATE_CONFIRM_BTN"] = "進む";
translations["MSG_PARENT_GATE_QUESTION_TITLE"] = "画像をこの順番でタップしてください:";
translations["MSG_PARENT_GATE_LONGPRESS_INSTRUCTION"] = "数字 「%{number}」 を長押ししてください。";
translations["MSG_PARENT_GATE_SHAPE_RECT"] = "四角";
translations["MSG_PARENT_GATE_SHAPE_STAR"] = "星型";
translations["MSG_PARENT_GATE_SHAPE_CIRCLE"] = "円形";
translations["MSG_PARENT_GATE_SHAPE_TRIANGLE"] = "三角";
translations["MSG_PARENTS_PROFILE_DEFAULT_NAME"] = "保護者";

translations["MSG_PARENT_REGISTRATION_MESSAGE_COURSE"] =
  "「体験プラン」で遊べるのは<br>「アルゴリズムをあそぼう」の<br>ステージ1と2だけです。";
translations["MSG_PARENT_REGISTRATION_MESSAGE_PROJECT_LIMIT"] =
  "「体験プラン」ではアプリは%{limit}個まで作れます。";
translations["MSG_PARENT_REGISTRATION_MESSAGE_CHILD_USER_LIMIT"] =
  "「体験プラン」ではプレイヤーは%{limit}名まで<br>追加できます。";
translations["MSG_PARENT_REGISTRATION_MESSAGE_AI_CHAT_LIMIT"] =
  "「体験プラン」では1日%{limit}回まで送れます。";
translations["MSG_PARENT_REGISTRATION_MESSAGE_AI_IMAGE_LIMIT"] =
  "「体験プラン」では1日%{limit}回まで作れます。";
translations["MSG_PARENT_REGISTRATION_MESSAGE_ASSET_LIMIT"] =
  "「体験プラン」では素材は100MBまで保存できます。";

translations["MSG_COURSE_COMING_SOON_WARNING_MESSAGE"] =
  "このカセットは まだ遊べないよ。\nもうちょっと待ってね！";
translations["MSG_COURSE_START_BTN"] = "スタート";
translations["MSG_COURSE_GOTO_MAP_BTN"] = "ステージへ";
translations["MSG_COURSE_STAGE_CLEAR_TITLE"] = "ここまでクリア！";
translations["MSG_COURSE_LEVEL_OVERVIEW_SUMMARY"] = "このレベルでまなぶこと";
translations["MSG_COURSE_LEVEL_OVERVIEW_START_BTN"] = "はじめる";
translations["MSG_COURSE_GAME_TIPS_NEXT_BTN"] = "つぎへ";
translations["MSG_COURSE_GAME_TIPS_BACK_BTN"] = "まえにもどる";
translations["MSG_COURSE_GAME_TIPS_ACTION_BTN"] = "やってみる";
translations["MSG_COURSE_GAME_HINT_BTN"] = "ヒント";
translations["MSG_COURSE_GAME_CLEAR"] = "クリア";
translations["MSG_COURSE_GAME_SCORE_TEXT"] = "てにいれたアイテム";
translations["MSG_COURSE_GAME_SCORE_STATUS"] = "こ/%{total}こ";
translations["MSG_COURSE_GAME_START_BTN"] = "スタート！";
translations["MSG_COURSE_GAME_RESET_BTN"] = "やりなおす";
translations["MSG_COURSE_GAME_SUCCESS_TEXT"] = "おめでとう!このレベルをクリアしたよ!";
translations["MSG_COURSE_GAME_SUCCESS_REVIEW_BTN"] = "みなおす";
translations["MSG_COURSE_GAME_SUCCESS_NEXT_LEVEL_BTN"] = "つぎのレベルにすすむ";
translations["MSG_COURSE_GAME_SUCCESS_NEXT_STAGE_BTN"] = "つぎのステージにすすむ";
translations["MSG_COURSE_GAME_FAILED_TITLE"] = "ざんねん！";
translations["MSG_COURSE_GAME_FAILED_TEXT"] =
  "もう一回やってみましょう！\n\n難しくてわからない時は、\nヒントを参考にしてください。";
translations["MSG_COURSE_GAME_FAILED_RESET_BTN"] = "もういっかいやる";
translations["MSG_COURSE_GAME_STAGE_CLEAR"] = "おめでとう!ステージをクリアしたよ!";
translations["MSG_COURSE_ALL_GAME_STAGE_CLEAR"] =
  "おめでとう！\nいま ちょうせんできる\nすべての ステージを クリアしたよ！\nあたらしい ステージが ついか されるまで\nたのしみに まっていてね！";
translations["MSG_COURSE_PROGRAM_RUN"] = "スタート";
translations["MSG_COURSE_ALGORITHM"] = "アルゴリズムをまなぼ！";
translations["MSG_COURSE_PROGRAM"] = "はじめてのプログラミング";
translations["MSG_COURSE_ALGORITHM_ADVANCED"] = "アルゴリズム上級";
translations["MSG_COURSE_SOKOBAN"] = "倉庫番パズル";
translations["MSG_COURSE_SOKOBAN_DESCRIPTION"] = "箱を押して、ゴールへ届けよう！";
translations["MSG_COURSE_SOKOBAN_LEVEL"] = "レベル";
translations["MSG_COURSE_PIECE_BUILDER"] = "ピースビルダー";
translations["MSG_BUILDER_TAB_MY_MAPS"] = "マイピース";
translations["MSG_BUILDER_TAB_PUBLIC_MAPS"] = "みんなのピース";
translations["MSG_BUILDER_TAB_TRASH"] = "ゴミ箱";
translations["MSG_BUILDER_PUBLIC_COMING_SOON"] = "もうすぐ公開予定！";
translations["MSG_BUILDER_DEMO_BUTTON"] = "DEMO";
translations["MSG_BUILDER_NEW_MAP_BTN"] = "新しいピース";
translations["MSG_BUILDER_NEW_MAP_TITLE"] = "新しいピースを作る";
translations["MSG_BUILDER_MAP_DETAIL_BTN"] = "詳細";
translations["MSG_BUILDER_MAP_EDIT_BTN"] = "編集";
translations["MSG_BUILDER_MAP_RUN_BTN"] = "動かす";
translations["MSG_BUILDER_MAP_COUNT"] = "ピース %{count} 個";
translations["MSG_BUILDER_FILTER_ALL"] = "全部";
translations["MSG_BUILDER_FILTER_FAVORITE"] = "お気に入り";
translations["MSG_BUILDER_FILTER_DRAFT"] = "下書き";
translations["MSG_BUILDER_FILTER_EDITING"] = "編集中";
translations["MSG_BUILDER_SORT_DESC"] = "新しい順";
translations["MSG_BUILDER_SORT_ASC"] = "古い順";
translations["MSG_BUILDER_SORT_POPULAR"] = "人気";
translations["MSG_BUILDER_PUBLIC_COUNT"] = "%{count} 個";
translations["MSG_BUILDER_PUBLIC_SEARCH_PLACEHOLDER"] = "ピース名・タグで探す";
translations["MSG_BUILDER_PUBLIC_FILTER_OFFICIAL"] = "公式";
translations["MSG_BUILDER_PUBLIC_FILTER_COPIED"] = "コピー";
translations["MSG_BUILDER_PUBLIC_FILTER_TAG"] = "タグ";
translations["MSG_BUILDER_TRASH_COUNT"] = "ゴミ箱 %{count} 個";
translations["MSG_BUILDER_TRASH_SORT"] = "削除した順";
translations["MSG_BUILDER_TRASH_NOTICE"] = "ピースは 30日で消えちゃうよ";
translations["MSG_BUILDER_TRASH_DAYS_LEFT"] = "あと %{days} 日";
translations["MSG_BUILDER_CARD_STATUS_DRAFT"] = "下書き";
translations["MSG_BUILDER_CARD_STATUS_EDITING"] = "編集中";
translations["MSG_BUILDER_CARD_STATUS_UNPUBLISHED"] = "非公開";
translations["MSG_BUILDER_CARD_STATUS_PUBLISHED"] = "公開中";
translations["MSG_BUILDER_CARD_STATUS_REMOVED"] = "削除済み";
translations["MSG_BUILDER_CARD_STATUS_OFFICIAL"] = "公式";
translations["MSG_BUILDER_CARD_BADGE_REMIX"] = "リミックス";
translations["MSG_BUILDER_CARD_REMIX_FROM"] = "オリジナル: %{name}";
translations["MSG_BUILDER_BTN_PLAY"] = "あそぶ";
translations["MSG_BUILDER_BTN_CONTINUE"] = "つづき";
translations["MSG_BUILDER_BTN_PUBLISHED_NOW"] = "今の公開";
translations["MSG_BUILDER_BTN_RESUME"] = "つづける";
translations["MSG_BUILDER_BTN_RESTORE"] = "もどす";
translations["MSG_BUILDER_BTN_DELETE_FOREVER"] = "けす";
translations["MSG_BUILDER_BTN_COPY"] = "コピー";
translations["MSG_BUILDER_MENU_HINT"] = "ヒントを書く";
translations["MSG_BUILDER_MENU_COPY"] = "コピーして作る";
translations["MSG_BUILDER_MENU_TO_TRASH"] = "ゴミ箱へ";
translations["MSG_BUILDER_MENU_LIKE"] = "いいね";
translations["MSG_BUILDER_MENU_REACTION"] = "リアクション";
translations["MSG_BUILDER_MENU_REPORT"] = "報告する";
translations["MSG_BUILDER_TO_TRASH_CONFIRM_TITLE"] = "ゴミ箱に入れる？";
translations["MSG_BUILDER_TO_TRASH_CONFIRM_MSG"] =
  "「%{name}」を ゴミ箱に入れるよ。あとで もどせるよ。";
translations["MSG_BUILDER_TO_TRASH_TOAST"] = "ゴミ箱へ入れたよ";
translations["MSG_BUILDER_TRASH_RESTORE_TOAST"] = "もどしたよ";
translations["MSG_BUILDER_TRASH_DELETE_CONFIRM_TITLE"] = "完全に消す？";
translations["MSG_BUILDER_TRASH_DELETE_CONFIRM_MSG"] =
  "「%{name}」を 完全に消すよ。もう もどせないよ。";
translations["MSG_BUILDER_TRASH_DELETE_TOAST"] = "消しちゃった";
translations["MSG_BUILDER_LIKE_TOAST"] = "いいね したよ";
translations["MSG_BUILDER_COPY_TOAST"] = "コピーしたよ";
translations["MSG_BUILDER_DETAIL_TAB_RANKING"] = "ランキング";
translations["MSG_BUILDER_DETAIL_AUTHOR_BY"] = "%{name} さんが作ったよ";
translations["MSG_BUILDER_DETAIL_APP_CODE"] = "アプリコード";
translations["MSG_BUILDER_DETAIL_PUBLISHED_AT"] = "公開日";
translations["MSG_BUILDER_DETAIL_UPDATED_AT"] = "更新日";
translations["MSG_BUILDER_DETAIL_RANKING_MOVES"] = "最短 手数";
translations["MSG_BUILDER_DETAIL_RANKING_TIME"] = "最速 タイム";
translations["MSG_BUILDER_DETAIL_RANKING_WORLD"] = "世界記録";
translations["MSG_BUILDER_DETAIL_RANKING_MOVES_UNIT"] = "%{n} 手";
translations["MSG_BUILDER_DETAIL_RANKING_YOU"] = "あなた";
translations["MSG_BUILDER_DETAIL_HINT_TITLE"] = "ヒントを書こう";
translations["MSG_BUILDER_DETAIL_HINT_DESC"] = "空っぽ なら自動で作ってくれるよ";
translations["MSG_BUILDER_DETAIL_HINT_LV1"] = "① やさしい";
translations["MSG_BUILDER_DETAIL_HINT_LV2"] = "② ふつう";
translations["MSG_BUILDER_DETAIL_HINT_LV3"] = "③ こたえ";
translations["MSG_BUILDER_DETAIL_HINT_PLACEHOLDER"] = "ヒントを書いてね";
translations["MSG_SOKOBAN_TUTORIAL_GOAL_TITLE"] = "ゲームの遊び方";
translations["MSG_SOKOBAN_TUTORIAL_GOAL_DESC"] = "箱を全部ゴールに乗せよう！";
translations["MSG_SOKOBAN_TUTORIAL_CONTROLLER_TITLE"] = "動かし方";
translations["MSG_SOKOBAN_TUTORIAL_CONTROLLER_DESC"] = "右下のボタンでキャラクターを動かせるよ";
translations["MSG_SOKOBAN_TUTORIAL_CAMERA_TITLE"] = "カメラ操作";
translations["MSG_SOKOBAN_TUTORIAL_CAMERA_DESC"] = "左下の丸をドラッグしてカメラを回せるよ";
translations["MSG_SOKOBAN_TUTORIAL_BTN_FORWARD"] = "前に進む";
translations["MSG_SOKOBAN_TUTORIAL_BTN_TURN_LEFT"] = "左に回る";
translations["MSG_SOKOBAN_TUTORIAL_BTN_TURN_RIGHT"] = "右に回る";
translations["MSG_SOKOBAN_TUTORIAL_BTN_JUMP"] = "ジャンプ";
translations["MSG_SOKOBAN_TUTORIAL_NEXT_BTN"] = "つぎへ";
translations["MSG_SOKOBAN_TUTORIAL_START_BTN"] = "はじめる！";
translations["MSG_SOKOBAN_TUTORIAL_TITLE"] = "チュートリアル";
translations["MSG_SOKOBAN_TUTORIAL_TAP_TO_CONTINUE"] = "タップして続ける";
translations["MSG_SOKOBAN_TUTORIAL_GOAL_HINT"] = "ここを目指そう！";
translations["MSG_COURSE_GROUP_WORK"] = "グループワーク";
translations["MSG_COURSE_COORDINATE_X"] = "横の位置（X座標）";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_NEXT_BTN"] = "つぎへ";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_LATER_BTN"] = "あとで見る";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_CONTINUE_BTN"] = "ガイドを続ける";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_ACTION_BTN"] = "やってみる";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_CLOSE_BTN"] = "ガイドを終わる";
translations["MSG_CREATOR_CREATE_APP"] = "アプリを\n作る";
translations["MSG_CREATOR_CREATE_APP_TITLE"] = "アプリを作る";
translations["MSG_CREATOR_CREATE_APP_NAME"] = "アプリに名前をつけてください。";
translations["MSG_CREATOR_CREATE_APP_NAME_PREFIX"] = "アプリ";
translations["MSG_CREATOR_APP_DETAIL_BTN"] = "詳しく";
translations["MSG_CREATOR_RUN_APP_BTN"] = "うごかす";
translations["MSG_CREATOR_APP_MY_APPS"] = "マイアプリ";
translations["MSG_CREATOR_APP_SHARED_APPS"] = "みんなのアプリ";
translations["MSG_CREATOR_APP_SHARED_APPS_EMPTY_MESSAGE"] =
  "この条件のアプリがありませんでした。\n条件を変えて、もう一度検索をしてください。";
translations["MSG_CREATOR_APP_DELETED_APPS"] = "ゴミ箱";
translations["MSG_CREATOR_APP_DELETED_APPS_MESSAGE"] =
  "「マイアプリ」に戻したいアプリを\n選んでください。\n（最近削除したアプリが\n5つまで残っています）";
translations["MSG_CREATOR_APP_SETTING_TITLE"] = "アプリの設定";
translations["MSG_CREATOR_APP_SETTING_APP_NAME"] = "アプリの名前";
translations["MSG_CREATOR_APP_SETTING_APP_TAG"] = "タグ";
translations["MSG_CREATOR_APP_SETTING_PUBLISH_TITLE"] = "みんなのアプリにのせる";
translations["MSG_CREATOR_APP_SETTING_PUBLISH_STATUS_OFF"] = "非公開";
translations["MSG_CREATOR_APP_SETTING_PUBLISH_STATUS_ON"] = "公開";
translations["MSG_CREATOR_APP_SETTING_ENABLE_COPIED_TITLE"] = "他の人がコピーできる";
translations["MSG_CREATOR_APP_SETTING_ENABLE_COPIED_STATUS_OFF"] = "コピーを\n禁止する";
translations["MSG_CREATOR_APP_SETTING_ENABLE_COPIED_STATUS_ON"] = "コピーを\n許可する";
translations["MSG_CREATOR_APP_SETTING_APP_CHANGE_COVER_PAGE_BTN"] = "表紙を変更";
translations["MSG_CREATOR_APP_DETAIL_APP_AUTHOR"] = "はじめに作った人";
translations["MSG_CREATOR_APP_DETAIL_APP_EDITOR"] = "作り変えた人";
translations["MSG_CREATOR_APP_NAME_PLACEHOLDER"] = "名前を入れてください";
translations["MSG_CREATOR_APP_SELECT_PLACEHOLDER"] = "select app";
translations["MSG_CREATOR_APP_DETAIL_DESCRIPTION_TITLE"] = "アプリの説明";
translations["MSG_CREATOR_APP_DETAIL_DESCRIPTION_NONE"] = "説明がありません";
translations["MSG_CREATOR_APP_DETAIL_DESCRIPTION_PLACEHOLDER"] = "アプリの説明を入力してください";
translations["MSG_CREATOR_APP_DETAIL_TITLE_APP_CODE"] = "アプリ\nコード";
translations["MSG_CREATOR_APP_DETAIL_TITLE_SHARED_APP"] = "みんなの\nアプリ";
translations["MSG_CREATOR_APP_DETAIL_TITLE_SHARED_APP_PUBLISHED"] = "公開中";
translations["MSG_CREATOR_APP_DETAIL_TITLE_SHARED_APP_NOT_PUBLISHED"] = "非公開";
translations["MSG_CREATOR_APP_DETAIL_INPUT_COPIED_STATUS"] = "ほかの\n人";
translations["MSG_CREATOR_APP_DETAIL_INPUT_COPIED_STATUS_ENABLE"] = "コピーできる";
translations["MSG_CREATOR_APP_DETAIL_INPUT_COPIED_STATUS_DISABLE"] = "コピーできない";
translations["MSG_CREATOR_APP_DETAIL_APP_DELETED_AT"] = "削除\nした日";
translations["MSG_CREATOR_APP_EDITOR_BTN"] = "つくる";
translations["MSG_CREATOR_APP_COMPLETELY_BTN"] = "完全に消す";
translations["MSG_CREATOR_APP_RESTORE_BTN"] = "元に戻す";
translations["MSG_CREATOR_APP_DELETE_WARNING_TITLE"] = "アプリを削除しますか？";
translations["MSG_CREATOR_APP_DELETE_WARNING_MESSAGE"] =
  "「%{name}」を削除します。\nアプリを編集できなくなります。\nアプリを使うことはできません。";
translations["MSG_CREATOR_ASSET_DELETE_WARNING_TITLE"] = "画像を削除しますか？";
translations["MSG_CREATOR_ASSET_DELETE_WARNING_MESSAGE"] =
  "「%{name}」を 削除します。\n画像を削除すると、元に戻せなくなります。";
translations["MSG_CREATOR_CREATE_APP_PICKUP_NAME"] = "ピックアップ";
translations["MSG_CREATOR_CREATE_APP_PICKUP_MONTH_TITLE"] = "%{month}月の";
translations["MSG_CREATOR_CREATE_APP_PICKUP_SUBTITLE"] = "きになるアプリをごしょうかい！";
translations["MSG_CREATOR_APP_PUBLISH_TITLE"] = "「みんなのアプリ」に公開しますか？";
translations["MSG_CREATOR_APP_PUBLISH_DISABLED_TITLE"] = "アプリの公開ができません";
translations["MSG_CREATOR_APP_PUBLISH_DISABLED_MESSAGE"] =
  "アプリの公開が許可されていません。\n保護者メニューから許可をしてください。";
translations["MSG_CREATOR_APP_DISABLE_PUBLISH_TITLE"] = "「みんなのアプリ」への公開をやめますか？";
translations["MSG_CREATOR_APP_PUBLISH_WARNING"] =
  "「%{name}」を「みんなのアプリ」に公開します。\nアプリを公開すると、ほかの人がこのアプリを使うことができるようになります。";
translations["MSG_CREATOR_APP_DISABLE_PUBLISH_WARNING"] =
  "「%{name}」を「みんなのアプリ」に公開しないようにします。\n公開をやめると、ほかの人がこのアプリを使えなくなります。";
translations["MSG_CREATOR_APP_PUBLISH_COPIED_ENABLE"] = "コピーを許可して公開";
translations["MSG_CREATOR_APP_PUBLISH_COPIED_DISABLE"] = "コピーを許可しないで公開";
translations["MSG_CREATOR_APP_PUBLISH_COPIED_NOTICE"] = "※アプリは後で公開をやめることもできます。";
translations["MSG_CREATOR_PUBLISH_CONFIRM_BTN"] = "公開する";
translations["MSG_CREATOR_DISABLE_PUBLISH_CONFIRM_BTN"] = "非公開にする";
translations["MSG_CREATOR_APP_ENABLE_COPIED_TITLE"] = "このアプリのコピーの設定";
translations["MSG_CREATOR_APP_DISABLE_COPIED_TITLE"] = "このアプリのコピーの設定";
translations["MSG_CREATOR_APP_ENABLE_COPIED_MESSAGE"] =
  "他の人が「%{name}」をコピーできるようにコピーを許可します。";
translations["MSG_CREATOR_APP_DISABLE_COPIED_MESSAGE"] =
  "他の人が「%{name}」をコピーできないように、コピー禁止にします。";
translations["MSG_CREATOR_ASSET_LIMIT_WARNING_TITLE"] = "この画像は利用できません";
translations["MSG_CREATOR_ASSET_LIMIT_WARNING_MESSAGE"] =
  "アプリに追加できる画像は最新の%{limit}個だけです。\nそれ以外の画像も利用できるようになりましたら、お知らせします。";
translations["MSG_CREATOR_APP_DELETE_PUBLISHED_WARNING_TITLE"] = "アプリを削除できません";
translations["MSG_CREATOR_APP_DELETE_PUBLISHED_WARNING_MESSAGE"] =
  "みんなのアプリに公開中のアプリは削除できません。\nこのアプリを削除したいときは、先に非公開にしてください。\n";
translations["MSG_CREATOR_APP_SORT_FILTER_TITLE"] = "見つける";
translations["MSG_CREATOR_APP_KEYWORD_SEARCH_TITLE"] = "言葉で見つける";
translations["MSG_CREATOR_APP_SORT_TITLE"] = "並べ替え";
translations["MSG_CREATOR_APP_SORT_FAVORITED"] = "人気";
translations["MSG_CREATOR_APP_SORT_VIEWED"] = "人気";
translations["MSG_CREATOR_APP_SORT_DATE"] = "時間";
translations["MSG_CREATOR_APP_FILTER_TITLE"] = "絞り込み";
translations["MSG_CREATOR_APP_FILTER_OFFICIAL"] = "公式";
translations["MSG_CREATOR_APP_FILTER_FAVORITED"] = "いいね";
translations["MSG_CREATOR_APP_DISABLE_BTN"] = "できません";
translations["MSG_CREATOR_APP_COMPLETE_DELETE_CONFIRM_TITLE"] = "アプリを完全に消しますか？";
translations["MSG_CREATOR_APP_COMPLETE_DELETE_CONFIRM_SUBTITLE"] =
  "「%{name}」を完全に消します。\n完全に消すと、アプリを元に戻すことはできなくなります。";
translations["MSG_CREATOR_APP_RESTORE_CONFIRM_TITLE"] = "「マイアプリ」に戻しますか？";
translations["MSG_CREATOR_APP_RESTORE_CONFIRM_SUBTITLE"] =
  "「%{name}」を「マイアプリ」に戻しますか？";
translations["MSG_CREATOR_SCREEN_LIST_HEADER"] = "ページ";
translations["MSG_CREATOR_COMPONENT_LIST_HEADER"] = "選択中";
translations["MSG_CREATOR_MENU_CONTEXT_DELETE"] = "削除";
translations["MSG_CREATOR_MENU_CONTEXT_COPY"] = "コピー";
translations["MSG_CREATOR_MENU_CASSETTE_ACTION"] = "カセット操作";
translations["MSG_CREATOR_MENU_RUN_APP_BTN"] = "アプリを\nうごかす";
translations["MSG_CREATOR_MENU_SET_APP_BTN"] = "アプリの\n設定";
translations["MSG_CREATOR_MENU_PUBLISH_APP_BTN"] = "アプリを\n公開";
translations["MSG_CREATOR_MENU_STOP_PUBLISH_APP_BTN"] = "アプリを\n非公開";
translations["MSG_CREATOR_MENU_PUBLISH_TEMPLATE_BTN"] = "テンプレートを\n公開";
translations["MSG_CREATOR_MENU_STOP_PUBLISH_TEMPLATE_BTN"] = "テンプレートを\n非公開";
translations["MSG_CREATOR_MENU_CLOSE_BTN"] = "この画面を\n閉じる";
translations["MSG_CREATOR_MENU_COMPONENT_BTN"] = "パーツ";
translations["MSG_CREATOR_MENU_COMPONENT_ACTION_BTN"] = "お仕事";
translations["MSG_CREATOR_MENU_COMPONENT_SHAPE_BTN"] = "図形";
translations["MSG_CREATOR_MENU_COMPONENT_STAMP_BTN"] = "スタンプ";
translations["MSG_CREATOR_MENU_COMPONENT_STOCK_BTN"] = "道具箱";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_ACTION"] = "操作パーツ";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_SHAPE"] = "図形パーツ";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP"] = "スタンプパーツ";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_CHARACTER"] = "キャラクター";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_GAME"] = "活動・遊び";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_ANIMAL"] = "生き物";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_EVENT"] = "イベント";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_INTERNET"] = "インターネット";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_MONEY"] = "経済・お金";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_GOODS"] = "生活雑貨";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_NATURE"] = "自然・植物";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_PERSON"] = "人物";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_BUILDING"] = "建物";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_FOOD"] = "食べ物";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_ELECTRONIC"] = "家電・通信";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_SMILE"] = "にこちゃん";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_VEHICLE"] = "乗り物";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_STATIONARY"] = "文房具";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_OTHERS"] = "自己紹介";
translations["MSG_CREATOR_MENU_DRAWING_BTN"] = "お絵かき";
translations["MSG_CREATOR_MENU_DRAWING_PEN"] = "ペン";
translations["MSG_CREATOR_MENU_DRAWING_ERASER"] = "消しゴム";
translations["MSG_CREATOR_MENU_DRAWING_SIZE"] = "太さ";
translations["MSG_CREATOR_MENU_DRAWING_SIZE_LIGHT"] = "細い";
translations["MSG_CREATOR_MENU_DRAWING_SIZE_NORMAL"] = "普通";
translations["MSG_CREATOR_MENU_DRAWING_SIZE_BOLD"] = "太い";
translations["MSG_CREATOR_MENU_DRAWING_COLOR"] = "色";
translations["MSG_CREATOR_MENU_DRAWING_RESET"] = "やり直す";
translations["MSG_CREATOR_MENU_DRAWING_FINISH"] = "完成";
translations["MSG_CREATOR_MENU_STOCK_PARTS_USE_BTN"] = "追加";
translations["MSG_CREATOR_MENU_COMPONENT_PREVIEW_TITLE"] = "%{name}のパーツ一覧";
translations["MSG_CREATOR_MENU_ASSET_CATEGORY_ALBUM_TITLE"] = "アルバム";
translations["MSG_CREATOR_MENU_ASSET_CATEGORY_DRAWING_TITLE"] = "スケッチブック";
translations["MSG_CREATOR_MENU_PROPERTY_BTN"] = "デザイン";
translations["MSG_CREATOR_MENU_PROPERTY_BASIC"] = "基本";
translations["MSG_CREATOR_MENU_PROPERTY_POSITION"] = "場所";
translations["MSG_CREATOR_MENU_PROPERTY_SIZE"] = "サイズ";
translations["MSG_CREATOR_MENU_PROPERTY_APPEARANCE"] = "見た目";
translations["MSG_CREATOR_MENU_PROPERTY_COLOR"] = "色";
translations["MSG_CREATOR_MENU_PROPERTY_LOGIC"] = "プログラム";
translations["MSG_CREATOR_MENU_PROPERTY_LOGIC_TITLE"] = "%{name}のプログラム";

translations["MSG_CREATOR_MENU_PROPERTY_NAME"] = "名前";
translations["MSG_CREATOR_MENU_PROPERTY_NAME_PLACEHOLDER"] = "名前を付けてください";
translations["MSG_CREATOR_MENU_PROPERTY_SET_TOP_PAGE_TITLE"] = "トップページ";
translations["MSG_CREATOR_MENU_PROPERTY_SET_TOP_PAGE"] = "このページからはじめる";
translations["MSG_CREATOR_MENU_PROPERTY_FONT_FAMILY"] = "フォントの種類";
translations["MSG_CREATOR_TEXT_WEIGHT_BOLD"] = "太い";
translations["MSG_CREATOR_TEXT_WEIGHT_REGULAR"] = "普通";
translations["MSG_CREATOR_TEXT_WEIGHT_LIGHT"] = "細い";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT"] = "表示する内容";
translations["MSG_CREATOR_MENU_PROPERTY_ZINDEX"] = "重なり";
translations["MSG_CREATOR_MENU_PROPERTY_ZINDEX_FRONT"] = "一番上へ";
translations["MSG_CREATOR_MENU_PROPERTY_ZINDEX_BACK"] = "一番下へ";
translations["MSG_CREATOR_MENU_PROPERTY_POSITION_X_Y"] = "横と縦の場所";
translations["MSG_CREATOR_MENU_PROPERTY_X"] = "横の場所";
translations["MSG_CREATOR_MENU_PROPERTY_Y"] = "縦の場所";
translations["MSG_CREATOR_MENU_PROPERTY_X_COORDINATE"] = "横";
translations["MSG_CREATOR_MENU_PROPERTY_Y_COORDINATE"] = "縦";
translations["MSG_CREATOR_MENU_PROPERTY_WIDTH"] = "横幅";
translations["MSG_CREATOR_MENU_PROPERTY_HEIGHT"] = "高さ";
translations["MSG_CREATOR_MENU_PROPERTY_BORDER"] = "枠";
translations["MSG_CREATOR_MENU_PROPERTY_SHADOW"] = "影";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_SIZE"] = "テキスト";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_SHADOW"] = "テキストの影";
translations["MSG_CREATOR_MENU_PROPERTY_OPACITY"] = "見えやすさ";
translations["MSG_CREATOR_MENU_PROPERTY_ROTATION"] = "角度";
translations["MSG_CREATOR_MENU_PROPERTY_BORDER_RADIUS"] = "角の丸さ";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO"] = "画像の情報";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_NAME"] = "名前";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_SIZE"] = "大きさ";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_FILE_SIZE"] = "ファイルサイズ";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_BTN"] = "画像を選ぶ";
translations["MSG_CREATOR_MENU_PROPERTY_BACKGROUND_COLOR"] = "塗りつぶし";
translations["MSG_CREATOR_MENU_PROPERTY_BORDER_COLOR"] = "枠";
translations["MSG_CREATOR_MENU_PROPERTY_SHADOW_COLOR"] = "影";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_COLOR"] = "テキスト";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_SHADOW_COLOR"] = "テキストの影";

translations["MSG_CREATOR_MENU_BLOCKLY_TITLE"] = "ブロック";
translations["MSG_CREATOR_MENU_BLOCKLY_EVENT"] = "イベント";
translations["MSG_CREATOR_MENU_BLOCKLY_ANIMATION"] = "動き";
translations["MSG_CREATOR_MENU_BLOCKLY_CONTROL"] = "制御";
translations["MSG_CREATOR_MENU_BLOCKLY_LOGIC"] = "ロジック";
translations["MSG_CREATOR_MENU_BLOCKLY_MATH"] = "演算";
translations["MSG_CREATOR_MENU_BLOCKLY_VARIABLE"] = "変数";
translations["MSG_CREATOR_MENU_BLOCKLY_PROCEDURE"] = "関数";
translations["MSG_CREATOR_MENU_BLOCKLY_PROMPT_INPUT_MESSAGE"] = "%{placeholder}の値";

translations["MSG_CREATOR_COMPONENT_NAME_SCREEN"] = "ページ";
translations["MSG_CREATOR_COMPONENT_NAME_BUTTON"] = "ボタン";
translations["MSG_CREATOR_COMPONENT_NAME_LABEL"] = "ラベル";
translations["MSG_CREATOR_COMPONENT_NAME_FORM"] = "フォーム";
translations["MSG_CREATOR_COMPONENT_NAME_CHECKBOX"] = "チェックボックス";
translations["MSG_CREATOR_COMPONENT_NAME_SWITCH"] = "スイッチ";
translations["MSG_CREATOR_COMPONENT_NAME_IMAGE"] = "画像";
translations["MSG_CREATOR_COMPONENT_NAME_CIRCLE"] = "円";
translations["MSG_CREATOR_COMPONENT_NAME_TRIANGLE"] = "三角";
translations["MSG_CREATOR_COMPONENT_NAME_RECT"] = "四角";
translations["MSG_CREATOR_COMPONENT_NAME_STAR"] = "星";
translations["MSG_CREATOR_COMPONENT_NAME_LINE"] = "線";
translations["MSG_CREATOR_COMPONENT_NAME_STAMP"] = "スタンプ";
translations["MSG_CREATOR_COMPONENT_NAME_DRAWING"] = "お絵描き";
translations["MSG_CREATOR_COMPONENT_LABEL_BUTTON"] =
  translations["MSG_CREATOR_COMPONENT_NAME_BUTTON"];
translations["MSG_CREATOR_COMPONENT_LABEL_LABEL"] =
  translations["MSG_CREATOR_COMPONENT_NAME_LABEL"];
translations["MSG_CREATOR_COMPONENT_LABEL_FORM"] = translations["MSG_CREATOR_COMPONENT_NAME_FORM"];
translations["MSG_CREATOR_COMPONENT_LABEL_CHECKBOX"] = "チェック\nボックス";
translations["MSG_CREATOR_COMPONENT_LABEL_SWITCH"] =
  translations["MSG_CREATOR_COMPONENT_NAME_SWITCH"];
translations["MSG_CREATOR_COMPONENT_LABEL_IMAGE"] = "画像\nボックス";
translations["MSG_CREATOR_COMPONENT_LABEL_CIRCLE"] =
  translations["MSG_CREATOR_COMPONENT_NAME_CIRCLE"];
translations["MSG_CREATOR_COMPONENT_LABEL_TRIANGLE"] =
  translations["MSG_CREATOR_COMPONENT_NAME_TRIANGLE"];
translations["MSG_CREATOR_COMPONENT_LABEL_RECT"] = translations["MSG_CREATOR_COMPONENT_NAME_RECT"];
translations["MSG_CREATOR_COMPONENT_LABEL_STAR"] = translations["MSG_CREATOR_COMPONENT_NAME_STAR"];
translations["MSG_CREATOR_COMPONENT_LABEL_LINE"] = translations["MSG_CREATOR_COMPONENT_NAME_LINE"];

translations["MSG_BLOCKLY_VARIABLES"] = "変数";
translations["MSG_BLOCKLY_INPUT_NUMBER_LIMIT"] = "数字を入力してください。";
translations["MSG_BLOCKLY_INPUT_LENGTH_LIMIT"] = "%{limit}文字以内で入力してください。";
translations["MSG_ASSET_ALBUM_TITLE"] = "アルバムの中身";
translations["MSG_ASSET_DRAWING_TITLE"] = "スケッチブックの中身";
translations["MSG_ASSET_ALBUM_ADD_TITLE"] = "画像の追加";
translations["MSG_ASSET_DRAWING_ADD_ALBUM_TITLE"] =
  "『まなんでパズル』で追加した、画像や写真がここに追加されます。";
translations["MSG_ASSET_DRAWING_ADD_WARNING_TITLE"] =
  "『じううにつくる』の「お絵かき」メニューで絵を書くと、ここに 追加されます。";
translations["MSG_ASSET_ADD_TO_SCREEN_BTN"] = "アプリに\n追加する";
translations["MSG_CREATOR_MENU_MATERIAL_TAB_ASSET_SELECT"] = "チャットに\n追加する";
translations["MSG_ASSET_DELETE_BTN"] = "画像を\n削除する";
translations["MSG_ASSET_ALBUM_EMPTY_MESSAGE"] = "まだ 画像のデータがありません。";
translations["MSG_ASSET_DRAWING_EMPTY_MESSAGE"] = "まだ お絵かきの データがありません。";
translations["MSG_ASSET_STORAGE_OVER_LIMIT"] = "ストレージがいっぱいです";
translations["MSG_REACTION_TAG_TITLE"] = "きもちスタンプ";
translations["MSG_REACTION_USERS"] = "みんなの\n気持ち";
translations["MSG_REACTION_DIFFICULT"] = "てごわい！";
translations["MSG_REACTION_EASY"] = "かんたん";
translations["MSG_REACTION_COOL"] = "いいね！";
translations["MSG_REACTION_FUN"] = "たのしい";
translations["MSG_REACTION_AMAZING"] = "すごい";
translations["MSG_REACTION_BAD"] = "う〜ん？";

translations["MSG_CURRENT_PLAN"] = "現在のプラン";
translations["MSG_PLAN_TRIAL"] = "体験";
translations["MSG_PLAN_SAKIDORI"] = "先取";
translations["MSG_PLAN_FREE"] = "無料";
translations["MSG_PLAN_STANDARD"] = "基本";
translations["MSG_PLAN_PREMIUM"] = "特別";
translations["MSG_PLAN_BUILDER"] = "ビルダー";
translations["MSG_PLAN_EDUCATION"] = "教室";
translations["MSG_PLAN_UNKNOWN"] = "不明";
translations["MSG_PLAN_FREE_FULL"] = "無料プラン";
translations["MSG_PLAN_STANDARD_FULL"] = "基本プラン";
translations["MSG_PLAN_PREMIUM_FULL"] = "特別プラン";
translations["MSG_PLAN_TRIAL_PARENT"] = "体験";
translations["MSG_PLAN_FREE_PARENT"] = "無料";
translations["MSG_PLAN_STANDARD_PARENT"] = "基本";
translations["MSG_PLAN_PREMIUM_PARENT"] = "特別";
translations["MSG_PLAN_BUILDER_PARENT"] = "ビルダー";
translations["MSG_PLAN_EDUCATION_PARENT"] = "教室";
translations["MSG_PLAN_UNKNOWN_PARENT"] = "不明";
translations["MSG_PLAN_FREE_FULL_PARENT"] = "無料プラン";
translations["MSG_PLAN_STANDARD_FULL_PARENT"] = "基本プラン";
translations["MSG_PLAN_PREMIUM_FULL_PARENT"] = "特別プラン";

translations["MSG_BACK_BTN"] = "戻る";
translations["MSG_SUBSCRIPTION_MONTHLY_TITLE"] = "月額プラン";
translations["MSG_SUBSCRIPTION_ANNUAL_TITLE"] = "年額プラン";
translations["MSG_SUBSCRIPTION_ANNUAL_BADGE"] = "2ヶ月分お得！";
translations["MSG_SUBSCRIPTION_PURCHASE_BTN"] = "購入する";
translations["MSG_SUBSCRIPTION_UPGRADE_BTN"] = "アップグレード";
translations["MSG_SUBSCRIPTION_PURCHASE_SUCCESS"] = "購入が完了しました！";
translations["MSG_SUBSCRIPTION_PURCHASE_ERROR"] = "購入に失敗しました。もう一度お試しください。";
translations["MSG_SUBSCRIPTION_REACTIVATE_SUCCESS"] = "購読を再開しました";
translations["MSG_SUBSCRIPTION_REACTIVATE_ERROR"] = "購読の再開に失敗しました";
translations["MSG_SUBSCRIPTION_PORTAL_ERROR"] = "ポータルを開けませんでした";

translations["MSG_SUBSCRIPTION_CANCEL_CONFIRM_TITLE"] = "本当に解約しますか？";
translations["MSG_SUBSCRIPTION_CANCEL_CONFIRM_MESSAGE"] =
  "解約すると、次回更新日から無料プランに戻ります。\n今までのデータは残ります。";
translations["MSG_SUBSCRIPTION_CANCEL_SUCCESS"] = "解約を受け付けました";
translations["MSG_SUBSCRIPTION_CANCEL_ERROR"] = "解約に失敗しました";
translations["MSG_PARENT_PAGE_TAB_ACCOUNT"] = "アカウント";
translations["MSG_PARENT_PAGE_TAB_PLAYER"] = "プレイヤー";
translations["MSG_PARENT_PAGE_TAB_SUBSCRIPTION"] = "課金管理";
translations["MSG_PARENT_PAGE_TAB_NOTIFICATION"] = "お知らせ";
translations["MSG_PARENT_PAGE_TAB_MESSAGE"] = "メッセージ";
translations["MSG_PARENT_PAGE_TAB_OTHER"] = "その他";

translations["MSG_PARENT_PAGE_MESSAGE_INPUT_PLACEHOLDER"] = "メッセージを入力...";
translations["MSG_PARENT_PAGE_MESSAGE_NO_ROOMS"] = "チャットルームがありません";
translations["MSG_PARENT_PAGE_MESSAGE_NO_MESSAGES"] = "メッセージはまだありません";
translations["MSG_PARENT_PAGE_MESSAGE_LOAD_MORE"] = "もっとみる";
translations["MSG_LOADING"] = "読み込み中...";

translations["MSG_PARENT_PAGE_SUBSCRIPTION_SOURCE"] = "購入方法";
translations["MSG_PARENT_PAGE_EDUCATION_DESCRIPTION"] =
  "教室プランをご利用中です。詳しくは管理者にお問い合わせください。";

translations["MSG_PARENT_PAGE_ACCOUNT_INFO"] = "アカウント情報";
translations["MSG_PARENT_PAGE_NICKNAME"] = "ニックネーム";
translations["MSG_PARENT_PAGE_ICON"] = "アイコン";
translations["MSG_PARENT_PAGE_EMAIL"] = "メールアドレス";
translations["MSG_PARENT_PAGE_EMAIL_VERIFIED"] = "メール認証";
translations["MSG_PARENT_PAGE_VERIFIED"] = "認証済み";
translations["MSG_PARENT_PAGE_CREATED_AT"] = "アカウント作成日";
translations["MSG_PARENT_PAGE_CHANGE"] = "変更";
translations["MSG_PARENT_PAGE_SNS_LINK"] = "アカウント連携";
translations["MSG_PARENT_PAGE_GOOGLE_ACCOUNT"] = "Googleアカウント";
translations["MSG_PARENT_PAGE_APPLE_ID"] = "Apple ID";
translations["MSG_PARENT_PAGE_LINK"] = "連携する";
translations["MSG_PARENT_PAGE_UNLINK"] = "連携解除";

translations["MSG_PARENT_PAGE_PROFILE_SECTION_TITLE"] = "プロフィール情報";
translations["MSG_PARENT_PAGE_PROFILE_EDIT_TITLE"] = "プロフィールを編集";
translations["MSG_PARENT_PAGE_PROFILE_NOT_SET"] = "未設定";
translations["MSG_PARENT_PAGE_PROFILE_BASIC_INFO"] = "基本情報";
translations["MSG_PARENT_PAGE_PROFILE_REGION_PLACEHOLDER"] = "例: 東京都";
translations["MSG_PARENT_PAGE_PROFILE_CITY_PLACEHOLDER"] = "例: 渋谷区";
translations["MSG_PARENT_PAGE_PROFILE_NOTES"] = "自己紹介";
translations["MSG_PARENT_PAGE_TAB_BASIC"] = "基本情報";
translations["MSG_PARENT_PAGE_TAB_FAVORITES"] = "個性";
translations["MSG_PARENT_PAGE_TAB_APPEARANCE"] = "見た目";
translations["MSG_PARENT_PAGE_NOT_SET"] = "未設定";
translations["MSG_PARENT_PAGE_EDIT_FAVORITE_COLOR"] = "好きな色を編集";
translations["MSG_PARENT_PAGE_EDIT_SELF_INTRO"] = "自己紹介を編集";
translations["MSG_PARENT_PAGE_PROFILE_UPDATE_SUCCESS"] = "プロフィールを更新しました";
translations["MSG_PARENT_PAGE_PROFILE_UPDATE_ERROR"] = "プロフィールの更新に失敗しました";

translations["MSG_ICON_CHANGE_PREVIEW_CURRENT"] = "現在";
translations["MSG_ICON_CHANGE_PREVIEW_SELECTED"] = "これにする？";
translations["MSG_ICON_CHANGE_CONFIRM_BTN"] = "確定";
translations["MSG_ICON_CHANGE_AI_CANCEL"] = "キャンセル";
translations["MSG_QUOTA_EXCEEDED"] = "今日は使い切っちゃったよ！また明日ね！";
translations["MSG_QUOTA_RESET_TIME"] = "明日0:00リセット";
translations["MSG_AI_PROCESSING"] = "AI生成中です...";

translations["MSG_ICON_CHANGE_PREVIEW_CURRENT_PARENT"] = "現在";
translations["MSG_ICON_CHANGE_PREVIEW_SELECTED_PARENT"] = "選択中";
translations["MSG_PARENT_PAGE_ACCOUNT_ACTIONS"] = "アカウント操作";
translations["MSG_PARENT_PAGE_CHANGE_PASSWORD"] = "パスワードを変更";
translations["MSG_PARENT_PAGE_LOGOUT"] = "ログアウト";
translations["MSG_PARENT_PAGE_NICKNAME_EDIT_TITLE"] = "ニックネームを変更";
translations["MSG_PARENT_PAGE_NICKNAME_EDIT_MESSAGE"] = "新しいニックネームを入力してください";
translations["MSG_PARENT_PAGE_NICKNAME_ERROR_MESSAGE"] = "他の名前をお試しください";
translations["MSG_PARENT_PAGE_ADD"] = "追加";
translations["MSG_PARENT_PAGE_ACTIVE"] = "アクティブ";
translations["MSG_PARENT_PAGE_INACTIVE"] = "非アクティブ";
translations["MSG_PARENT_PAGE_PLAYABLE"] = "プレイ可能";
translations["MSG_PARENT_PAGE_SUSPENDED"] = "停止中";
translations["MSG_PARENT_PAGE_SWITCH_LOGIN"] = "切り替え";
translations["MSG_PARENT_PAGE_FROZEN_DIALOG_TITLE"] = "切り替えできません";
translations["MSG_PARENT_PAGE_FROZEN_DIALOG_MESSAGE"] =
  "このプレイヤーは停止中のため、ログインに切り替えることができません。先にプレイヤーを有効化してください。";
translations["MSG_PARENT_PAGE_SWITCH_CONFIRM_TITLE"] = "プレイヤーを切り替えますか？";
translations["MSG_PARENT_PAGE_SWITCH_CONFIRM_MESSAGE"] = "「%{name}」に切り替えます。";
translations["MSG_PARENT_PAGE_BASIC_INFO"] = "基本情報";
translations["MSG_PARENT_PAGE_AGE"] = "年齢";
translations["MSG_PARENT_PAGE_YEARS_OLD"] = "歳";
translations["MSG_PARENT_PAGE_GENDER"] = "性別";
translations["MSG_PARENT_PAGE_BIRTHDAY"] = "誕生日";
translations["MSG_PARENT_PAGE_ACCOUNT_CREATED_DATE"] = "アカウント追加日";
translations["MSG_GENDER_SELECT_TITLE"] = "どちらかを選んでね";
translations["MSG_GENDER_STATUS_LABEL"] = "性別";
translations["MSG_GENDER_NOT_SELECTED"] = "未選択";
translations["MSG_GENDER_MALE"] = "男の子";
translations["MSG_GENDER_FEMALE"] = "女の子";
translations["MSG_GENDER_NONE"] = "なし";
translations["MSG_PARENT_PAGE_CHILD_NAME_EDIT_TITLE"] = "名前変更";
translations["MSG_PARENT_PAGE_CHILD_NAME_EDIT_MESSAGE"] = "新しい名前を入力してください";
translations["MSG_PARENT_PAGE_YEAR"] = "年";
translations["MSG_PARENT_PAGE_MONTH"] = "月";
translations["MSG_PARENT_PAGE_DAY"] = "日";
translations["MSG_PARENT_PAGE_GENDER_EDIT_TITLE"] = "性別変更";
translations["MSG_PARENT_PAGE_GENDER_EDIT_MESSAGE"] = "性別を選択してください";
translations["MSG_PARENT_PAGE_BIRTHDAY_EDIT_TITLE"] = "誕生日変更";
translations["MSG_PARENT_PAGE_LANGUAGE_EDIT_TITLE"] = "表示言語変更";
translations["MSG_PARENT_PAGE_LANGUAGE_EDIT_MESSAGE"] = "表示言語を選択してください";
translations["MSG_PARENT_PAGE_ADD_CHILD_LIMIT_TITLE"] = "プレイヤーを追加できません";
translations["MSG_PARENT_PAGE_ADD_CHILD_LIMIT_MESSAGE"] =
  "現在のプランでは最大{{limit}}人までプレイヤーを追加できます。\nプランをアップグレードすると、より多くのプレイヤーを追加できます。";
translations["MSG_PARENT_PAGE_DELETE_CHILD_TITLE"] = "プレイヤーを削除しますか？";
translations["MSG_PARENT_PAGE_DELETE_CHILD_MESSAGE"] =
  "{{name}}を削除すると、このプレイヤーの全てのデータ（進捗、作品など）が失われます。\nこの操作は取り消せません。";
translations["MSG_PARENT_PAGE_DELETE_CHILD_MIN_TITLE"] = "プレイヤーを削除できません";
translations["MSG_PARENT_PAGE_DELETE_CHILD_MIN_MESSAGE"] =
  "最低1人のプレイヤーが必要です。\n削除する前に別のプレイヤーを追加してください。";
translations["MSG_PARENT_PAGE_DANGER_ZONE"] = "危険な操作";
translations["MSG_PARENT_PAGE_DELETE_CHILD"] = "プレイヤーを削除";
translations["MSG_PARENT_PAGE_DELETE_CHILD_WARNING"] = "このプレイヤーの全てのデータが削除されます";
translations["MSG_PARENT_PAGE_DELETE_BTN"] = "削除";
translations["MSG_PARENT_PAGE_COURSE_CLEAR"] = "コースクリア";
translations["MSG_PARENT_PAGE_CREATED_PROJECTS"] = "つくった作品";
translations["MSG_PARENT_PAGE_PUBLISHED_PROJECTS"] = "公開した作品";
translations["MSG_PARENT_PAGE_RECEIVED_LIKES"] = "もらったいいね";
translations["MSG_PARENT_PAGE_SETTINGS"] = "設定";
translations["MSG_PARENT_PAGE_DISPLAY_LANGUAGE"] = "表示言語";
translations["MSG_PARENT_PAGE_HIRAGANA"] = "ひらがな";
translations["MSG_PARENT_PAGE_KANJI"] = "漢字";
translations["MSG_PARENT_PAGE_PROJECT_PUBLISH"] = "作品の公開";
translations["MSG_PARENT_PAGE_COPY_PERMISSION"] = "コピー許可";
translations["MSG_PARENT_PAGE_AI_CHAT"] = "まなパルくんとの会話";
translations["MSG_PARENT_PAGE_AI_GENERATION"] = "AIで素材作成";
translations["MSG_PARENT_PAGE_ACCOUNT_STATUS"] = "アカウント状態";
translations["MSG_PARENT_PAGE_DANGER_ZONE"] = "危険な操作";
translations["MSG_PARENT_PAGE_DELETE_CHILD_WARNING"] =
  "すべての学習データ・作品が削除されます。この操作は取り消せません。";
translations["MSG_PARENT_PAGE_DELETE_CHILD"] = "このプレイヤーを削除";
translations["MSG_PARENT_PAGE_DELETE_BTN"] = "削除する";
translations["MSG_PARENT_PAGE_RECENT_ACTIVITY"] = "最近の活動";
translations["MSG_PARENT_PAGE_NO_ACTIVITY_24H"] = "24時間以内の活動はありません";
translations["MSG_PARENT_PAGE_RECENT_ACTIVITY_24H"] = "最近24時間の活動";
translations["MSG_PARENT_PAGE_TODAY"] = "今日";
translations["MSG_PARENT_PAGE_YESTERDAY"] = "昨日";

translations["MSG_ACTIVITY_COURSE_CLEAR"] = "%{course}のステージ%{stage} レベル%{level}をクリア！";
translations["MSG_ACTIVITY_PROJECT_CREATED"] = "「%{name}」をつくりました";
translations["MSG_ACTIVITY_PROJECT_PUBLISHED"] = "「%{name}」をこうかいしました";
translations["MSG_ACTIVITY_PROJECT_FAVORITED"] = "「%{name}」にいいねしました";
translations["MSG_ACTIVITY_FAVORITED_RECEIVED"] = "いいねをもらいました";
translations["MSG_ACTIVITY_LOGIN"] = "ログインしました";
translations["MSG_ACTIVITY_ICON_CHANGED"] = "アイコンをかえました";
translations["MSG_ACTIVITY_AI_CHAT"] = "AIと会話しました";
translations["MSG_ACTIVITY_INQUIRY_SENT"] = "おといあわせをおくりました";
translations["MSG_ACTIVITY_APP_REVIEWED"] = "アプリを★%{rating}でひょうかしました";
translations["MSG_ACTIVITY_FEEDBACK_SENT"] = "フィードバックをそうしんしました";
translations["MSG_ACTIVITY_COIN_EARNED"] = "%{amount}コインをかくとくしました";
translations["MSG_ACTIVITY_COIN_SPENT"] = "%{amount}コインをつかいました";
translations["MSG_ACTIVITY_LOGIN_STREAK"] = "%{days}にちれんぞくログインたっせい！";
translations["MSG_ACTIVITY_DEFAULT"] = "かつどうしました";

// 保護者ページ - アクティビティログ（保護者向け・漢字統一）
translations["MSG_PARENT_PAGE_ACTIVITY_COURSE_CLEAR"] =
  "%{course}のステージ%{stage} レベル%{level}をクリア！";
translations["MSG_PARENT_PAGE_ACTIVITY_PROJECT_CREATED"] = "「%{name}」を作成しました";
translations["MSG_PARENT_PAGE_ACTIVITY_PROJECT_PUBLISHED"] = "「%{name}」を公開しました";
translations["MSG_PARENT_PAGE_ACTIVITY_PROJECT_FAVORITED"] = "「%{name}」にいいねしました";
translations["MSG_PARENT_PAGE_ACTIVITY_FAVORITED_RECEIVED"] = "いいねをもらいました";
translations["MSG_PARENT_PAGE_ACTIVITY_LOGIN"] = "ログインしました";
translations["MSG_PARENT_PAGE_ACTIVITY_ICON_CHANGED"] = "アイコンを変更しました";
translations["MSG_PARENT_PAGE_ACTIVITY_AI_CHAT"] = "AIと会話しました";
translations["MSG_PARENT_PAGE_ACTIVITY_INQUIRY_SENT"] = "問い合わせを送信しました";
translations["MSG_PARENT_PAGE_ACTIVITY_APP_REVIEWED"] = "アプリを★%{rating}で評価しました";
translations["MSG_PARENT_PAGE_ACTIVITY_FEEDBACK_SENT"] = "フィードバックを送信しました";
translations["MSG_PARENT_PAGE_ACTIVITY_DEFAULT"] = "活動しました";

translations["MSG_PARENT_PAGE_PLAYER_PROJECTS"] = "作品一覧";
translations["MSG_PARENT_PAGE_PLAYER_PROJECTS_EMPTY"] = "まだアプリがありません";
translations["MSG_PARENT_PAGE_PLAYER_ASSETS"] = "素材一覧";
translations["MSG_PARENT_PAGE_PLAYER_ASSETS_LIST"] = "素材一覧";
translations["MSG_PARENT_PAGE_PLAYER_ASSETS_EMPTY"] = "まだ素材がありません";
translations["MSG_PARENT_PAGE_PLAYER_SHOW_MORE"] = "もっと見る";
translations["MSG_PARENT_PAGE_PLAYER_ALBUM"] = "アルバム";
translations["MSG_PARENT_PAGE_PLAYER_SKETCHBOOK"] = "スケッチブック";
translations["MSG_PARENT_PAGE_PLAYER_AI_IMAGE"] = "AI画像";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_PUBLISHED"] = "公開中";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_UNPUBLISHED"] = "未公開";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_VIEWS"] = "回閲覧";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_LIKES"] = "いいね";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_COPIES"] = "回コピー";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_CREATED"] = "作成日";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_UPDATED"] = "更新日";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_CREATED"] = "作成日";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_SIZE"] = "サイズ";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_UNNAMED"] = "名前なし";

translations["MSG_PARENT_PAGE_FEEDBACK_HISTORY"] = "フィードバック履歴";
translations["MSG_PARENT_PAGE_FEEDBACK_HISTORY_EMPTY"] = "まだフィードバックがありません";
translations["MSG_PARENT_PAGE_FEEDBACK_TYPE_RATING"] = "アプリの評価";
translations["MSG_PARENT_PAGE_FEEDBACK_TYPE_FEEDBACK"] = "フィードバック";
translations["MSG_PARENT_PAGE_FEEDBACK_TYPE_CONTACT"] = "お問い合わせ";
translations["MSG_PARENT_PAGE_FEEDBACK_RATING_SUMMARY"] = "アプリを★%{rating}で評価しました";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_HOW_TO"] = "使い方について";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_BUG"] = "不具合報告";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_REQUEST"] = "機能リクエスト";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_OTHER"] = "自己紹介";
translations["MSG_PARENT_PAGE_FEEDBACK_REPLIED"] = "返信済み";
translations["MSG_PARENT_PAGE_FEEDBACK_PENDING"] = "未返信";
translations["MSG_PARENT_PAGE_FEEDBACK_DETAIL"] = "フィードバック詳細";

translations["MSG_PARENT_PAGE_AI_CHAT_HISTORY"] = "まなパルくんとの会話履歴";
translations["MSG_PARENT_PAGE_AI_CHAT_HISTORY_EMPTY"] = "まだ会話履歴がありません";
translations["MSG_PARENT_PAGE_AI_CHAT_MESSAGE_COUNT"] = "%{count}件のメッセージ";
translations["MSG_PARENT_PAGE_AI_CHAT_NO_TITLE"] = "タイトルなし";
translations["MSG_PARENT_PAGE_AI_CHAT_NO_MESSAGES"] = "メッセージがありません";

translations["MSG_PARENT_PAGE_CURRENT_PLAN"] = "現在のプラン";
translations["MSG_PARENT_PAGE_MONTHLY_PRICE"] = "月額料金";
translations["MSG_PARENT_PAGE_PLAN_COMPARISON"] = "プラン比較";
translations["MSG_PARENT_PAGE_USER_COUNT"] = "プレイヤー数";
translations["MSG_PARENT_PAGE_PEOPLE"] = "人";
translations["MSG_PARENT_PAGE_PROJECT_COUNT"] = "「じゆうにつくる」の作品数";
translations["MSG_PARENT_PAGE_PROJECTS"] = "作品";
translations["MSG_PARENT_PAGE_AI_CHAT_FEATURE"] = "まなパルくんとの会話";
translations["MSG_PARENT_PAGE_AI_IMAGE_FEATURE"] = "AIで素材画像生成";
translations["MSG_PARENT_PAGE_AI_CHAT_FREE_LIMIT"] = "5回/日";
translations["MSG_PARENT_PAGE_AI_IMAGE_FREE_LIMIT"] = "2回/日";
translations["MSG_PARENT_PAGE_AI_CHAT_TAGLINE"] = "AIキャラクターと楽しく会話できる！";
translations["MSG_PARENT_PAGE_AI_CHAT_BENEFIT_1"] = "質問や相談に答えてくれる";
translations["MSG_PARENT_PAGE_AI_CHAT_BENEFIT_2"] = "お子様の好奇心を育む会話体験";
translations["MSG_PARENT_PAGE_AI_CHAT_BENEFIT_3"] = "アイデアの相談もできる";
translations["MSG_PARENT_PAGE_AI_IMAGE_TAGLINE"] = "想像したものを画像にできる！";
translations["MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_1"] = "オリジナルアイコンを作成";
translations["MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_2"] = "「じゆうにつくる」の素材に";
translations["MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_3"] = "チャットにも送れる";
translations["MSG_PARENT_PAGE_UNLIMITED"] = "無制限";
translations["MSG_PARENT_PAGE_CHAT_HISTORY_FEATURE"] = "会話履歴";
translations["MSG_PARENT_PAGE_CHAT_HISTORY_FREE_LIMIT"] = "100件まで";
translations["MSG_PARENT_PAGE_AI_CHAT_STANDARD_LIMIT"] = "無制限";
translations["MSG_PARENT_PAGE_AI_CHAT_PREMIUM_LIMIT"] = "無制限";
translations["MSG_PARENT_PAGE_AI_IMAGE_STANDARD_LIMIT"] = "無制限（同時1枚生成）";
translations["MSG_PARENT_PAGE_AI_IMAGE_PREMIUM_LIMIT"] = "無制限（同時3枚生成）";
translations["MSG_PARENT_PAGE_FREE"] = "無料";
translations["MSG_PARENT_PAGE_PLAN_INFO"] = "プラン情報";
translations["MSG_PARENT_PAGE_UPGRADE_SECTION"] = "プラン購入";
translations["MSG_PARENT_PAGE_SELECT_BILLING_PERIOD"] = "契約期間を選択";
translations["MSG_PARENT_PAGE_ANNUAL_PRICE"] = "年額料金";

translations["MSG_PARENT_PAGE_DOWNLOAD_PARENTS_APP"] = "保護者アプリをダウンロード";
translations["MSG_PARENT_PAGE_APP_DESCRIPTION"] =
  "保護者アプリを使って、お子様の学習状況を確認したり、設定を管理できます。";
translations["MSG_PARENT_PAGE_LEARNING_SUPPORT"] = "学習サポート";
translations["MSG_PARENT_PAGE_COURSE_ANSWER"] = "コースの解答を見る";
translations["MSG_PARENT_PAGE_VIEW_TUTORIAL"] = "チュートリアルを見る";
translations["MSG_PARENT_PAGE_CORPORATE_CODE"] = "企業連携コード";
translations["MSG_PARENT_PAGE_ENABLE_CORPORATE"] = "企業認証コードを入力";
translations["MSG_PARENT_PAGE_CORPORATE_DESCRIPTION"] =
  "企業提携コードをお持ちの方は、こちらから入力してください。";
translations["MSG_PARENT_PAGE_CORPORATE_AUTH_DESCRIPTION"] =
  "『まなんでパズル』認証コード（企業提携コード）をお持ちの方は、下記に指定されたコードを入力してください。";
translations["MSG_PARENT_PAGE_CORPORATE_AUTH_CODE_INPUT"] = "認証コード入力";
translations["MSG_PARENT_PAGE_CORPORATE_CONFIRM"] = "決定";
translations["MSG_PARENT_PAGE_CORPORATE_ALLOWED_CONTENT"] = "許可されたコンテンツ（カセット）";
translations["MSG_PARENT_PAGE_CORPORATE_NO_CONTENT"] =
  "許可された追加コンテンツ（カセット）はありません。";
translations["MSG_PARENT_PAGE_DATE_FORMAT"] = "MM月DD日";
translations["MSG_AI_PRESET_CAT"] = "猫";
translations["MSG_AI_PRESET_DOG"] = "犬";
translations["MSG_AI_PRESET_RABBIT"] = "兎";
translations["MSG_AI_PRESET_BEAR"] = "熊";
translations["MSG_AI_PRESET_BIRD"] = "鳥";
translations["MSG_AI_PRESET_NINJA"] = "忍者";
translations["MSG_AI_PRESET_WIZARD"] = "魔法使い";
translations["MSG_AI_PRESET_ROBOT"] = "ロボット";

translations["MSG_OPTIONAL"] = "任意";
translations["MSG_REQUIRED"] = "必須";
translations["MSG_AI_STYLE_CYBERPUNK"] = "サイバーパンク";
translations["MSG_AI_STYLE_ANIME"] = "アニメ";
translations["MSG_AI_STYLE_DRAMATIC"] = "ドラマチック";
translations["MSG_AI_STYLE_COLORING"] = "塗り絵";
translations["MSG_AI_STYLE_PHOTO"] = "写真";
translations["MSG_AI_STYLE_RETRO_MANGA"] = "レトロ漫画";
translations["MSG_AI_STYLE_EIGHTIES"] = "80年代";
translations["MSG_AI_STYLE_ART_NOUVEAU"] = "アールヌーボー";
translations["MSG_AI_STYLE_SYNTHWAVE"] = "シンセウェーブ";

translations["MSG_AI_EXPRESSION_SMILE"] = "笑顔";
translations["MSG_AI_EXPRESSION_COOL"] = "クール";
translations["MSG_AI_EXPRESSION_SLEEPY"] = "眠い";
translations["MSG_AI_EXPRESSION_SURPRISED"] = "驚き";

translations["MSG_AI_ACCESSORY_HAT"] = "帽子";
translations["MSG_AI_ACCESSORY_GLASSES"] = "眼鏡";
translations["MSG_AI_ACCESSORY_RIBBON"] = "リボン";
translations["MSG_AI_ACCESSORY_CROWN"] = "王冠";

translations["MSG_AI_BACKGROUND_STARRY"] = "星空";
translations["MSG_AI_BACKGROUND_MEADOW"] = "草原";
translations["MSG_AI_BACKGROUND_SPACE"] = "宇宙";
translations["MSG_AI_BACKGROUND_FLOWER"] = "花畑";

translations["MSG_TOAST_AI_GENERATION_FAILED"] = "AI画像の生成に失敗しました。";
translations["MSG_USER_STOCK_AI_TAB"] = "AIアトリエ";
translations["MSG_USER_STOCK_AI_TITLE"] = "AIアトリエ";
translations["MSG_USER_STOCK_AI_EMPTY"] = "AIで作った画像はありません";
translations["MSG_USER_STOCK_AI_HINT"] = "AI生成とAI加工で作った画像がここに追加されます";

translations["MSG_AI_IMAGE_SAVED"] = "AI画像を素材に保存しました";
translations["MSG_AI_TAB_GENERATE"] = "生成";
translations["MSG_CREATE_USER_BTN_NEXT"] = "次へ";
translations["MSG_CREATE_USER_BTN_GENERATE"] = "アイコンを作る";
translations["MSG_PROFILE_SUBSTEP_GENDER"] = "性別";
translations["MSG_PROFILE_SUBSTEP_BIRTHDAY"] = "誕生日";
translations["MSG_PROFILE_SUBSTEP_FAVORITES"] = "好きなもの";
translations["MSG_PROFILE_SUBSTEP_ICON"] = "アイコン";
translations["MSG_ICON_GENERATING"] = "プロフィールをもとに\nアイコンを作っているよ...";
translations["MSG_ICON_CONFIRM_PROMPT"] = "このアイコンで大丈夫？";
translations["MSG_ICON_CONFIRM_BTN"] = "これでいい！";
translations["MSG_ICON_REGENERATE_BTN"] = "もう一度作る";
translations["MSG_ICON_CREATE_BTN"] = "作る";
translations["MSG_ICON_ADDITIONAL_PROMPT_PLACEHOLDER"] = "追加したいことがあれば";
translations["MSG_ICON_ADDITIONAL_PROMPT_HINT"] = "好きな色やものを入力してもう一度作れるよ！";

translations["MSG_CREATE_USER_TITLE_GENDER"] = "君はどっち？";
translations["MSG_CREATE_USER_TITLE_BIRTHDAY"] = "お誕生日はいつ？";
translations["MSG_CREATE_USER_TITLE_PREVIEW"] = "これでいいかな？";

translations["MSG_ICON_SELECT_UPLOAD"] = "画像をアップロード";
translations["MSG_UPLOAD_ICON_TITLE"] = "画像をアップロードしてね";
translations["MSG_UPLOAD_ICON_SELECT"] = "画像を選ぶ";
translations["MSG_UPLOAD_ICON_HINT"] = "JPG、PNG形式、5MBまで";
translations["MSG_UPLOAD_ICON_CHANGE"] = "別の画像に変える";
translations["MSG_UPLOAD_ICON_REMOVE"] = "画像を消す";
translations["MSG_PROFILE_TAB_BASIC"] = "基本";
translations["MSG_PROFILE_TAB_APPEARANCE"] = "見た目";
translations["MSG_PROFILE_TAB_FAVORITES"] = "個性";
translations["MSG_PROFILE_TAB_GAME_CASE"] = "ゲーム\nケース";
translations["MSG_PROFILE_MULTI_SELECT"] = "いくつでも選べるよ";
translations["MSG_PROFILE_NOT_SET"] = "まだ選んでないよ";
translations["MSG_PROFILE_SELF_INTRODUCTION_NOT_SET"] = "まだ 入力してないよ";
translations["MSG_PROFILE_CHANGE_BTN"] = "変更";
translations["MSG_PROFILE_EDIT_COLOR_TITLE"] = "好きな色を選ぼう";
translations["MSG_PROFILE_EDIT_BEST_SUBJECTS_TITLE"] = "得意な教科を選んでね";
translations["MSG_SELECT_PLACEHOLDER"] = "選んでね";

translations["MSG_PROFILE_AI_FAVORITE_COLOR"] = "好きな色";
translations["MSG_PROFILE_AI_FAVORITE_ANIMAL"] = "好きな動物";
translations["MSG_PROFILE_AI_FAVORITE_FOOD"] = "好きな食べ物";
translations["MSG_PROFILE_AI_STRENGTH"] = "得意なこと";
translations["MSG_PROFILE_AI_OTHER_INFO"] = "自己紹介";
translations["MSG_PROFILE_AI_OTHER_INFO_PLACEHOLDER"] = "自分のことを書いてね";
translations["MSG_PROFILE_AI_BEST_SUBJECTS"] = "得意な教科";
translations["MSG_PROFILE_AI_GLASSES"] = "メガネ";
translations["MSG_PROFILE_AI_ACCESSORY"] = "身につけるもの";
translations["MSG_PROFILE_AI_HAIRSTYLE"] = "髪型";
translations["MSG_PROFILE_AI_BODY_TYPE"] = "体型";
translations["MSG_PROFILE_AI_FACE_SHAPE"] = "顔の形";
translations["MSG_PROFILE_EDIT_ACCESSORY_TITLE"] = "身につけるものを選んでね";
// 身につけるもの選択肢
translations["MSG_ACCESSORY_NONE"] = "なし";
translations["MSG_ACCESSORY_MEGANE"] = "メガネ";
translations["MSG_ACCESSORY_BOUSHI"] = "帽子";
translations["MSG_ACCESSORY_HAIRPIN"] = "ヘアピン";
translations["MSG_ACCESSORY_RIBBON"] = "リボン";
translations["MSG_ACCESSORY_BANDAID"] = "ばんそうこう";

translations["MSG_COLOR_RED"] = "赤";
translations["MSG_COLOR_BLUE"] = "青";
translations["MSG_COLOR_PINK"] = "ピンク";
translations["MSG_COLOR_GREEN"] = "緑";
translations["MSG_COLOR_YELLOW"] = "黄色";
translations["MSG_COLOR_PURPLE"] = "紫";
translations["MSG_COLOR_WHITE"] = "白";

translations["MSG_COLOR_SELECT_SHADE"] = "好きな色味を選んでね";

translations["MSG_ANIMAL_CAT"] = "ねこ";
translations["MSG_ANIMAL_DOG"] = "いぬ";
translations["MSG_ANIMAL_RABBIT"] = "うさぎ";
translations["MSG_ANIMAL_BEAR"] = "くま";
translations["MSG_ANIMAL_BIRD"] = "とり";
translations["MSG_ANIMAL_DINOSAUR"] = "恐竜";

translations["MSG_FOOD_CURRY"] = "カレー";
translations["MSG_FOOD_RAMEN"] = "ラーメン";
translations["MSG_FOOD_SUSHI"] = "お寿司";
translations["MSG_FOOD_HAMBURGER"] = "ハンバーグ";
translations["MSG_FOOD_PIZZA"] = "ピザ";
translations["MSG_FOOD_ICE_CREAM"] = "アイスクリーム";
translations["MSG_FOOD_FRUIT"] = "果物";
translations["MSG_FOOD_CAKE"] = "ケーキ";

translations["MSG_STRENGTH_SPORTS"] = "スポーツ";
translations["MSG_STRENGTH_DRAWING"] = "お絵かき";
translations["MSG_STRENGTH_MUSIC"] = "音楽";
translations["MSG_STRENGTH_READING"] = "読書";
translations["MSG_STRENGTH_MATH"] = "算数";
translations["MSG_STRENGTH_GAMES"] = "ゲーム";
translations["MSG_STRENGTH_CRAFTS"] = "工作";
translations["MSG_STRENGTH_COOKING"] = "料理";

translations["MSG_INTEREST_PROGRAMMING"] = "プログラミング";
translations["MSG_INTEREST_SCIENCE"] = "科学";
translations["MSG_INTEREST_ART"] = "アート";
translations["MSG_INTEREST_MUSIC"] = "音楽";
translations["MSG_INTEREST_SPORTS"] = "スポーツ";
translations["MSG_INTEREST_NATURE"] = "自然";
translations["MSG_INTEREST_SPACE"] = "宇宙";
translations["MSG_INTEREST_ANIMALS"] = "動物";

translations["MSG_SUBJECT_LANGUAGE"] = "国語";
translations["MSG_SUBJECT_MATH"] = "算数";
translations["MSG_SUBJECT_SCIENCE"] = "理科";
translations["MSG_SUBJECT_SOCIAL"] = "社会";
translations["MSG_SUBJECT_MUSIC"] = "音楽";
translations["MSG_SUBJECT_ART"] = "図工";
translations["MSG_SUBJECT_PE"] = "体育";
translations["MSG_SUBJECT_LIFE"] = "生活";
translations["MSG_SUBJECT_HOME_EC"] = "家庭";
translations["MSG_SUBJECT_ETHICS"] = "道徳";
translations["MSG_SUBJECT_ENGLISH"] = "英語";
translations["MSG_SUBJECT_INTEGRATED"] = "総合";
translations["MSG_SUBJECT_SPECIAL_ACTIVITIES"] = "特活";

// 得意な教科（保護者向け）

translations["MSG_GLASSES_NONE"] = "なし";
translations["MSG_GLASSES_YES"] = "あり";
translations["MSG_HAIRSTYLE_VERY_SHORT"] = "かなり短め";
translations["MSG_HAIRSTYLE_SHORT"] = "短め";
translations["MSG_HAIRSTYLE_MEDIUM"] = "普通";
translations["MSG_HAIRSTYLE_SLIGHTLY_LONG"] = "やや長め";
translations["MSG_HAIRSTYLE_LONG"] = "長め";
translations["MSG_BODY_TYPE_THIN"] = "細め";
translations["MSG_BODY_TYPE_SLIGHTLY_THIN"] = "やや細め";
translations["MSG_BODY_TYPE_MEDIUM"] = "普通";
translations["MSG_BODY_TYPE_SLIGHTLY_CHUBBY"] = "やや太め";
translations["MSG_BODY_TYPE_CHUBBY"] = "太め";
translations["MSG_FACE_SHAPE_ROUND"] = "丸型";
translations["MSG_FACE_SHAPE_OVAL"] = "卵型";
translations["MSG_FACE_SHAPE_OBLONG"] = "面長";
translations["MSG_FACE_SHAPE_SQUARE"] = "四角型";
translations["MSG_FACE_SHAPE_TRIANGLE"] = "三角型";

translations["MSG_BIRTHDAY_YEAR_SUFFIX"] = "年";
translations["MSG_BIRTHDAY_MONTH_SUFFIX"] = "月";
translations["MSG_BIRTHDAY_DAY_SUFFIX"] = "日";

translations["MSG_AI_IMAGE_PLAN_LABEL"] = "プラン";
translations["MSG_AI_IMAGE_USAGE_TODAY"] = "今日 %{remaining}/%{limit}回";
translations["MSG_AI_IMAGE_UNLIMITED"] = "使い放題";
translations["MSG_AI_IMAGE_COUNT_PER_REQUEST"] = "1回で%{count}枚";

translations["MSG_PARENT_ONBOARDING_NAME_PLACEHOLDER"] = "名前";
translations["MSG_PARENT_ONBOARDING_NICKNAME_TITLE"] = "ニックネームを入力してください";
translations["MSG_PARENT_ONBOARDING_NICKNAME_LENGTH_LIMIT"] = "10文字まで";
translations["MSG_PARENT_ONBOARDING_NICKNAME_LENGTH_ERROR"] = "10文字以内で入力してください";
translations["MSG_PARENT_ONBOARDING_ICON_PRESET"] = "用意された\nアイコン";
translations["MSG_PARENT_ONBOARDING_ICON_PRESET_TITLE"] = "アイコンを選択してください";
translations["MSG_PARENT_ONBOARDING_ICON_METHOD_TITLE"] = "アイコンを選択してください";
translations["MSG_PARENT_ONBOARDING_ICON_PROFILE_AI"] = "AIで自動で\nプロフィールから\n作る";
translations["MSG_PARENT_ONBOARDING_ICON_UPLOAD"] = "画像を\nアップロード";
translations["MSG_PARENT_ONBOARDING_GENDER_TITLE"] = "性別";
translations["MSG_PARENT_ONBOARDING_BIRTHDAY_TITLE"] = "生年月日";
translations["MSG_PARENT_ONBOARDING_BIRTHDAY_SELECT"] = "選択";
translations["MSG_PARENT_ONBOARDING_OCCUPATION_TITLE"] = "職業";
translations["MSG_PARENT_ONBOARDING_OCCUPATION_OPTIONAL"] = "（任意）";
translations["MSG_PARENT_ONBOARDING_OCCUPATION_PLACEHOLDER"] = "例：会社員、自営業";
translations["MSG_PARENT_ONBOARDING_ICON_PREVIEW_GENERATING"] = "生成中...";
translations["MSG_PARENT_ONBOARDING_ICON_PREVIEW_CONFIRM"] = "確認";
translations["MSG_PARENT_ONBOARDING_BTN_NEXT"] = "次へ";
translations["MSG_PARENT_ONBOARDING_BTN_BACK"] = "戻る";
translations["MSG_PARENT_ONBOARDING_BTN_GENERATE"] = "作成";
translations["MSG_PARENT_ONBOARDING_BTN_REGENERATE"] = "再生成";
translations["MSG_PARENT_ONBOARDING_BTN_CONFIRM"] = "確定";
translations["MSG_PARENT_ONBOARDING_BTN_COMPLETE"] = "完了";
translations["MSG_PARENT_ONBOARDING_UPLOAD_TITLE"] = "アイコンをアップロード";
translations["MSG_PARENT_ONBOARDING_UPLOAD_SELECT"] = "選択";
translations["MSG_PARENT_ONBOARDING_UPLOAD_HINT"] = "JPG、PNG（5MB以下）";
translations["MSG_PARENT_ONBOARDING_GENDER_MALE"] = "男性";
translations["MSG_PARENT_ONBOARDING_GENDER_FEMALE"] = "女性";
translations["MSG_PARENT_ONBOARDING_GENDER_NONE"] = "なし";
translations["MSG_PARENT_ONBOARDING_ORGANIZATION_TITLE"] = "所属先";
translations["MSG_PARENT_ONBOARDING_ORGANIZATION_PLACEHOLDER"] = "例：株式会社〇〇";
translations["MSG_PARENT_ONBOARDING_JOB_TITLE_TITLE"] = "役職";
translations["MSG_PARENT_ONBOARDING_JOB_TITLE_PLACEHOLDER"] = "例：課長、エンジニア";
translations["MSG_PARENT_ONBOARDING_REGION_TITLE"] = "お住まいの地域";
translations["MSG_PARENT_ONBOARDING_FAMILY_TITLE"] = "家族構成";
translations["MSG_PARENT_ONBOARDING_FAMILY_STRUCTURE_SINGLE"] = "単身";
translations["MSG_PARENT_ONBOARDING_FAMILY_STRUCTURE_COUPLE"] = "夫婦のみ";
translations["MSG_PARENT_ONBOARDING_FAMILY_STRUCTURE_NUCLEAR"] = "核家族";
translations["MSG_PARENT_ONBOARDING_FAMILY_STRUCTURE_EXTENDED"] = "三世代同居";
translations["MSG_PARENT_ONBOARDING_CHILDREN_COUNT_TITLE"] = "子どもの人数";
translations["MSG_PARENT_ONBOARDING_SPOUSE_TITLE"] = "配偶者";
translations["MSG_PARENT_ONBOARDING_SPOUSE_YES"] = "あり";
translations["MSG_PARENT_ONBOARDING_SPOUSE_NO"] = "なし";
translations["MSG_PARENT_ONBOARDING_HOBBIES_TITLE"] = "趣味";
translations["MSG_PARENT_ONBOARDING_HOBBIES_HINT"] = "複数選択可能";
translations["MSG_PARENT_ONBOARDING_HOBBIES_SPORTS"] = "スポーツ";
translations["MSG_PARENT_ONBOARDING_HOBBIES_MUSIC"] = "音楽";
translations["MSG_PARENT_ONBOARDING_HOBBIES_READING"] = "読書";
translations["MSG_PARENT_ONBOARDING_HOBBIES_TRAVEL"] = "旅行";
translations["MSG_PARENT_ONBOARDING_HOBBIES_COOKING"] = "料理";
translations["MSG_PARENT_ONBOARDING_HOBBIES_GAMING"] = "ゲーム";
translations["MSG_PARENT_ONBOARDING_HOBBIES_OUTDOOR"] = "アウトドア";
translations["MSG_PARENT_ONBOARDING_HOBBIES_ART"] = "アート";
translations["MSG_PARENT_ONBOARDING_HOBBIES_MOVIES"] = "映画";
translations["MSG_PARENT_ONBOARDING_HOBBIES_PHOTOGRAPHY"] = "写真";

translations["MSG_CREATE_USER_STEP_NAME"] = "名前";
translations["MSG_CREATE_USER_STEP_ICON"] = "アイコン";
translations["MSG_CREATE_USER_STEP_CONFIRM"] = "確認";
translations["MSG_ICON_SELECT_TITLE"] = "自分のアイコンを選ぼう！";
translations["MSG_ICON_SELECT_SYSTEM"] = "用意された\nアイコン";
translations["MSG_ICON_SELECT_SYSTEM_DESC"] = "いろんなキャラクターから選べるよ";
translations["MSG_ICON_SELECT_PROFILE_AI"] = "プロフィールで\nAIで自動で\n作る";
translations["MSG_ICON_SELECT_PROFILE_AI_DESC"] = "好きなことを入れると作ってくれるよ";
translations["MSG_ICON_SELECT_MATERIAL"] = "素材から\n選ぶ";
translations["MSG_ICON_SELECT_MATERIAL_DESC"] = "画像をアップロードもできるよ";
translations["MSG_SYSTEM_ICON_TITLE"] = "プリセットから選ぶ";
translations["MSG_ICON_CATEGORY_ALL"] = "すべて";
translations["MSG_ICON_CATEGORY_BOY"] = "男の子";
translations["MSG_ICON_CATEGORY_GIRL"] = "女の子";
translations["MSG_PROFILE_AI_APPEARANCE"] = "外見";
translations["MSG_GLASSES_TITLE"] = "メガネ";
translations["MSG_HAIRSTYLE_TITLE"] = "髪型";
translations["MSG_BODY_TYPE_TITLE"] = "体型";
translations["MSG_FACE_SHAPE_TITLE"] = "顔の形";
translations["MSG_REGENERATE_BTN"] = "もう一度作る";
translations["MSG_PROFILE_AI_GENERATE_BTN"] = "アイコンを作る！";
translations["MSG_PROFILE_AI_GENERATING"] = "作ってるよ...";
translations["MSG_PROFILE_AI_GENDER_TITLE"] = "性別";
translations["MSG_PROFILE_AI_OPTIONS_TITLE"] = "お好み";
translations["MSG_PROFILE_AI_BIRTHDAY_TITLE"] = "誕生日";
translations["MSG_PROFILE_AI_BIRTHDAY_SELECT"] = "選んでね";
translations["MSG_PROFILE_AI_OCCUPATION"] = "お仕事";
translations["MSG_PROFILE_AI_OCCUPATION_PLACEHOLDER"] = "例: 会社員、自営業など";
translations["MSG_PROFILE_AI_BEST_SUBJECT"] = "得意な教科";
translations["MSG_AI_MATERIAL_MODAL_TITLE"] = "AI画像を作ろう！";
translations["MSG_AI_MATERIAL_PROMPT_LABEL"] = "何を作る？";
translations["MSG_AI_MATERIAL_PROMPT_PLACEHOLDER_1"] = "かわいい犬";
translations["MSG_AI_MATERIAL_PROMPT_PLACEHOLDER_2"] = "走って楽しそう";
translations["MSG_AI_MATERIAL_GENERATE_BUTTON"] = "作る！";
translations["MSG_USER_PROFILE_EDIT_BTN"] = "変更";
translations["MSG_AI_EDUCATION_LIMIT_TITLE"] = "使えないよ";
translations["MSG_AI_EDUCATION_LIMIT_MESSAGE"] = "教室プランではこの機能は使えないよ";
translations["MSG_GENDER_MALE_PARENT"] = "男性";
translations["MSG_GENDER_FEMALE_PARENT"] = "女性";
translations["MSG_GENDER_OTHER_PARENT"] = "その他";
translations["MSG_GENDER_PREFER_NOT_TO_SAY"] = "回答しない";
translations["MSG_GENDER_NOT_SPECIFIED"] = "未設定";

translations["MSG_TOAST_PROJECT_QUOTA_EXCEEDED"] = "アプリの上限に達しました";
translations["MSG_CREATOR_APP_LIMIT"] = "アプリを作れません";
translations["MSG_CREATOR_APP_LIMIT_TITLE"] = "アプリを作れません";
translations["MSG_CREATOR_APP_LIMIT_MESSAGE"] =
  "今使っているプランではアプリを%{limit}個まで作れます\n新しいアプリを作るにはいらないアプリを消してください";
translations["MSG_CREATOR_TUTORIAL_LIMIT"] = "ガイドを動かせません";
translations["MSG_CREATOR_TUTORIAL_LIMIT_TITLE"] = "ガイドを動かせません";
translations["MSG_CREATOR_TUTORIAL_LIMIT_MESSAGE"] =
  "今使っているプランではアプリを%{limit}個まで作れます\n新しいアプリを作るにはいらないアプリを消してください";
translations["MSG_TOAST_AI_QUOTA_EXCEEDED"] = "今日のAIは終わりです";
translations["MSG_TOAST_AI_ACCESS_DENIED"] = "この機能は使えません";
translations["MSG_ERROR_NETWORK"] = "ネットワークエラー";
translations["MSG_TOAST_ERROR"] = "エラーが発生しました";
translations["MSG_TOAST_FILE_TOO_LARGE"] = "ファイルが大きすぎます";
translations["MSG_PARENT_PAGE_EDIT_BEST_SUBJECT"] = "得意教科を編集";
translations["MSG_PARENT_PAGE_EDIT_GLASSES"] = "メガネを編集";
translations["MSG_PARENT_PAGE_EDIT_HAIRSTYLE"] = "髪型を編集";
translations["MSG_PARENT_PAGE_EDIT_BODY_TYPE"] = "体型を編集";
translations["MSG_PARENT_PAGE_EDIT_FACE_SHAPE"] = "顔の形を編集";
translations["MSG_SUBJECT_JAPANESE"] = "国語";
translations["MSG_PROFILE_AI_FAVORITE_COLOR_PARENT"] = "好きな色";
translations["MSG_SUBSCRIPTION_STORE_MANAGE_TITLE"] = "サブスクリプション管理";
translations["MSG_SUBSCRIPTION_MANAGE_APP_STORE_MESSAGE"] =
  "App Storeで購入されたサブスクリプションの管理はApp Storeで行ってください";
translations["MSG_SUBSCRIPTION_MANAGE_PLAY_STORE_MESSAGE"] =
  "Google Playで購入されたサブスクリプションの管理はGoogle Playで行ってください";
translations["MSG_SUBSCRIPTION_PLATFORM_MISMATCH_TITLE"] = "別のプラットフォームで購入";
translations["MSG_SUBSCRIPTION_PLATFORM_MISMATCH_MESSAGE"] =
  "このサブスクリプションは別のプラットフォームで購入されました";
translations["MSG_PARENT_PAGE_BILLING_PERIOD"] = "請求期間";
translations["MSG_SUBSCRIPTION_MONTHLY_LABEL"] = "月額";
translations["MSG_SUBSCRIPTION_ANNUAL_LABEL"] = "年額";
translations["MSG_SUBSCRIPTION_MANAGE"] = "サブスク管理";
translations["MSG_SUBSCRIPTION_COMPARISON_RECOMMENDED"] = "おすすめ";
translations["MSG_PARENT_ONBOARDING_STEP_NAME"] = "名前";
translations["MSG_PARENT_ONBOARDING_STEP_ICON"] = "アイコン";
translations["MSG_PARENT_ONBOARDING_STEP_COMPLETE"] = "確認";
translations["MSG_PARENT_PROFILE_APPEARANCE"] = "見た目";
translations["MSG_PARENT_PROFILE_WORK"] = "就業状況";
translations["MSG_PARENT_PROFILE_REGION"] = "お住まい";
translations["MSG_PARENT_PROFILE_FAMILY"] = "家族構成";
translations["MSG_HOUSEHOLD_MEMBER_MOTHER"] = "母親";
translations["MSG_HOUSEHOLD_MEMBER_FATHER"] = "父親";
translations["MSG_HOUSEHOLD_MEMBER_GRANDMOTHER"] = "祖母";
translations["MSG_HOUSEHOLD_MEMBER_GRANDFATHER"] = "祖父";
translations["MSG_COMPANY_SIZE_TITLE"] = "会社規模";
translations["MSG_COMPANY_SIZE_SOLO"] = "個人事業主";
translations["MSG_COMPANY_SIZE_MICRO"] = "1-10人";
translations["MSG_COMPANY_SIZE_SMALL"] = "11-50人";
translations["MSG_COMPANY_SIZE_MEDIUM"] = "51-300人";
translations["MSG_COMPANY_SIZE_LARGE"] = "301-1000人";
translations["MSG_COMPANY_SIZE_ENTERPRISE"] = "1001人以上";
translations["MSG_INDUSTRY_TITLE"] = "業種";
translations["MSG_INDUSTRY_IT"] = "IT・通信";
translations["MSG_INDUSTRY_MANUFACTURING"] = "製造業";
translations["MSG_INDUSTRY_FINANCE"] = "金融・保険";
translations["MSG_INDUSTRY_RETAIL"] = "小売・卸売";
translations["MSG_INDUSTRY_HEALTHCARE"] = "医療・福祉";
translations["MSG_INDUSTRY_EDUCATION"] = "教育";
translations["MSG_INDUSTRY_GOVERNMENT"] = "官公庁・公務員";
translations["MSG_INDUSTRY_REAL_ESTATE"] = "不動産";
translations["MSG_INDUSTRY_CONSTRUCTION"] = "建設";
translations["MSG_INDUSTRY_TRANSPORTATION"] = "運輸・物流";
translations["MSG_INDUSTRY_MEDIA"] = "メディア・広告";
translations["MSG_INDUSTRY_SERVICE"] = "サービス業";
translations["MSG_INDUSTRY_OTHER"] = "その他";
translations["MSG_OCCUPATION_TITLE"] = "職種";
translations["MSG_OCCUPATION_EXECUTIVE"] = "経営者・役員";
translations["MSG_OCCUPATION_MANAGER"] = "管理職";
translations["MSG_OCCUPATION_ENGINEER"] = "エンジニア・技術職";
translations["MSG_OCCUPATION_SALES"] = "営業";
translations["MSG_OCCUPATION_MARKETING"] = "マーケティング";
translations["MSG_OCCUPATION_HR"] = "人事";
translations["MSG_OCCUPATION_ACCOUNTING"] = "経理・財務";
translations["MSG_OCCUPATION_RESEARCHER"] = "研究職";
translations["MSG_OCCUPATION_TEACHER"] = "教員";
translations["MSG_OCCUPATION_DOCTOR"] = "医師";
translations["MSG_OCCUPATION_NURSE"] = "看護師";
translations["MSG_OCCUPATION_LAWYER"] = "弁護士";
translations["MSG_OCCUPATION_DESIGNER"] = "デザイナー";
translations["MSG_OCCUPATION_FREELANCE"] = "フリーランス";
translations["MSG_OCCUPATION_HOMEMAKER"] = "専業主婦・主夫";
translations["MSG_OCCUPATION_STUDENT"] = "学生";
translations["MSG_OCCUPATION_OTHER"] = "その他";
translations["MSG_JOB_TITLE_LABEL"] = "役職・立場";
translations["MSG_JOB_TITLE_EXECUTIVE"] = "経営者・役員";
translations["MSG_JOB_TITLE_MANAGER"] = "管理職";
translations["MSG_JOB_TITLE_GENERAL"] = "一般職";
translations["MSG_JOB_TITLE_PROFESSIONAL"] = "専門職";
translations["MSG_JOB_TITLE_HOMEMAKER"] = "役職なし（専業主婦／主夫）";
translations["MSG_JOB_TITLE_STUDENT"] = "役職なし（学生）";
translations["MSG_JOB_TITLE_UNEMPLOYED"] = "役職なし（無職）";
translations["MSG_PREFECTURE_TITLE"] = "都道府県";
translations["MSG_CITY_TITLE"] = "地域";
translations["MSG_HOUSEHOLD_MEMBERS_TITLE"] = "同居人";
translations["MSG_BOYS_COUNT"] = "男の子";
translations["MSG_GIRLS_COUNT"] = "女の子";
translations["MSG_PARENT_ONBOARDING_INCOME_TITLE"] = "世帯収入";
translations["MSG_PARENT_ONBOARDING_INCOME_UNDER_5M"] = "500万円未満";
translations["MSG_PARENT_ONBOARDING_INCOME_5M_10M"] = "500〜1000万円";
translations["MSG_PARENT_ONBOARDING_INCOME_OVER_10M"] = "1000万円以上";
translations["MSG_PARENT_ONBOARDING_INCOME_PREFER_NOT_TO_SAY"] = "回答しない";
translations["MSG_PARENT_ONBOARDING_OTHER_INFO_TITLE"] = "自己紹介";
translations["MSG_PARENT_ONBOARDING_OTHER_INFO_PLACEHOLDER"] =
  "趣味、特技、お子様の年齢など、自由にご記入ください";

// 保護者ページ - チャット画像機能制限
translations["MSG_PARENTS_CHAT_IMAGE_RESTRICTION_TITLE"] = "画像機能について";
translations["MSG_PARENTS_CHAT_IMAGE_RESTRICTION_MESSAGE"] =
  "画像の送信は「特別プラン」で使えます\n特別プランにアップグレードすると、画像を送ることができます";
translations["MSG_PARENTS_CHAT_IMAGE_RESTRICTION_BTN"] = "プランを見る";

translations["MSG_AI_LABEL"] = "AI";
translations["MSG_BUILDER_MAP_NAME_PLACEHOLDER"] = "ピースの名前";
translations["MSG_BUILDER_TEST_BTN"] = "テスト";
translations["MSG_BUILDER_ASSET_LIST_TITLE"] = "パーツを選ぼう";
translations["MSG_BUILDER_ASSET_CATEGORY_DECORATION"] = "飾り";
translations["MSG_BUILDER_ASSET_CATEGORY_GROUND"] = "地面";
translations["MSG_BUILDER_ASSET_CATEGORY_GROUND_HINT"] = "地面の高さに置けるよ";
translations["MSG_BUILDER_BLOCKLY_SETTINGS_TITLE"] = "使えるブロック";
translations["MSG_BUILDER_BLOCKLY_CATEGORY_MOTION"] = "動き";
translations["MSG_BUILDER_BLOCKLY_CATEGORY_CONTROL"] = "繰り返し";
translations["MSG_BUILDER_BLOCK_MOVE_FORWARD"] = "前に進む";
translations["MSG_BUILDER_BLOCK_TURN_LEFT"] = "左を向く";
translations["MSG_BUILDER_BLOCK_TURN_RIGHT"] = "右を向く";
translations["MSG_BUILDER_BLOCK_JUMP"] = "ジャンプ";
translations["MSG_BUILDER_BLOCK_LOOP"] = "○回繰り返す";
translations["MSG_BUILDER_BLOCK_IF_COLOR"] = "もし○色なら";
translations["MSG_BUILDER_BLOCK_WHILE_COLOR"] = "○色まで繰り返す";
translations["MSG_BUILDER_BLOCKLY_SELECTED_COUNT"] = "%{count}個のブロックを選択中";
translations["MSG_OK_BTN"] = "OK";
translations["MSG_BUILDER_AI_MAP_TITLE"] = "AIでマップを作る";
translations["MSG_BUILDER_AI_PROMPT_LABEL"] = "どんなマップにする？（なくてもOK）";
translations["MSG_BUILDER_AI_PROMPT_PLACEHOLDER"] = "例: 迷路みたいなステージ";
translations["MSG_BUILDER_DIFFICULTY_LABEL"] = "難易度";
translations["MSG_BUILDER_DIFFICULTY_EASY"] = "簡単";
translations["MSG_BUILDER_DIFFICULTY_MEDIUM"] = "普通";
translations["MSG_BUILDER_DIFFICULTY_HARD"] = "難しい";
translations["MSG_BUILDER_AI_GENERATING"] = "作っています...";
translations["MSG_BUILDER_AI_GENERATION_FAILED"] = "マップの生成に失敗しました";
// ピースビルダー: PublishStepsPanel（spec §5.8.3）
translations["MSG_BUILDER_PUBLISH_PANEL_TITLE"] = "完成の準備";
translations["MSG_BUILDER_PUBLISH_PROGRESS_DONE"] = "これで 完成！";
translations["MSG_BUILDER_STEP_CHARACTER"] = "キャラクター";
translations["MSG_BUILDER_STEP_GOAL"] = "ゴール";
translations["MSG_BUILDER_STEP_BLOCKS"] = "ブロック";
translations["MSG_BUILDER_STEP_TEST"] = "テスト";
translations["MSG_BUILDER_STEP_META"] = "ピース情報";
translations["MSG_BUILDER_STEP_BLOCKS_COUNT"] = "%{count}個 設定";
translations["MSG_BUILDER_STEP_BTN_PLACE"] = "置く";
translations["MSG_BUILDER_STEP_BTN_SETTING"] = "設定";
translations["MSG_BUILDER_STEP_BTN_RETRY"] = "もう一度";
translations["MSG_BUILDER_STEP_BTN_EDIT"] = "編集";
translations["MSG_BUILDER_EDIT_HISTORY"] = "編集履歴";
translations["MSG_BUILDER_EDIT_HISTORY_EMPTY"] = "まだ編集履歴はありません";
translations["MSG_BUILDER_COMPLETE_BTN"] = "できた！";
translations["MSG_BUILDER_PUBLISH_SHARE_BTN"] = "みんなに 公開する";
translations["MSG_BUILDER_KEEP_DRAFT_BTN"] = "まだ 作り続ける";
translations["MSG_BUILDER_PUBLISH_HINT"] = "公開すると 他の人が 遊べるよ";
translations["MSG_BUILDER_COMPLETE_TOAST"] = "完成 したよ！";
translations["MSG_BUILDER_COMPLETE_FAILED"] = "まだ できていない 所が あるよ";
// ピースビルダー: ドラフト編集（spec §5.8.7/§5.8.8）
translations["MSG_BUILDER_DRAFT_EDITING_PILL"] = "下書き 編集中";
translations["MSG_BUILDER_DISCARD_DRAFT_BTN"] = "下書きを 破棄";
translations["MSG_BUILDER_DISCARD_DRAFT_CONFIRM"] = "編集を やめても いい？";
// ピースビルダー: AIChatModal（spec §5.8.5）
translations["MSG_BUILDER_AI_CHAT_TITLE"] = "AIで 作る";
translations["MSG_BUILDER_AI_CHAT_SUBTITLE"] = "会話で マップを 作ろう";
translations["MSG_BUILDER_AI_QUOTA"] = "今日の 残り: %{remaining}/%{limit}";
translations["MSG_BUILDER_AI_GREETING"] = "どんな マップを 作る？";
translations["MSG_BUILDER_AI_PLAN_LABEL"] = "案 %{n}";
translations["MSG_BUILDER_AI_USE_THIS"] = "これを 使う";
translations["MSG_BUILDER_AI_REGENERATE"] = "もう一度 3案";
translations["MSG_BUILDER_AI_RECOMMENDED"] = "（おすすめ）";
translations["MSG_BUILDER_AI_SESSION_EXPIRED"] =
  "これまでの 会話は 消えちゃったよ。もう一度 最初から 話そう";
translations["MSG_BUILDER_AI_SEND_BTN"] = "送る";
translations["MSG_BUILDER_AI_INPUT_PLACEHOLDER"] = "追加の 指示を 書こう";
// ピースビルダー: BuilderTutorialOverlay（spec §5.8.6）
translations["MSG_BUILDER_TUTORIAL_STEP1_TITLE"] = "キャラクターを 置こう！";
translations["MSG_BUILDER_TUTORIAL_STEP1_DESC"] = "下の キャラクターを マップに 置いてね";
translations["MSG_BUILDER_TUTORIAL_STEP2_TITLE"] = "ゴールを 置こう！";
translations["MSG_BUILDER_TUTORIAL_STEP2_DESC"] = "次は ゴールの 旗を 置こう";
translations["MSG_BUILDER_TUTORIAL_STEP3_TITLE"] = "ブロックを 並べよう！";
translations["MSG_BUILDER_TUTORIAL_STEP3_DESC"] = "道や 植物を 置いて マップを 作ろう";
translations["MSG_BUILDER_TUTORIAL_STEP4_TITLE"] = "テストで 動かそう！";
translations["MSG_BUILDER_TUTORIAL_STEP4_DESC"] = "上の テストボタンで 遊んで みよう";
translations["MSG_BUILDER_TUTORIAL_STEP5_TITLE"] = "公開しよう！";
translations["MSG_BUILDER_TUTORIAL_STEP5_DESC"] = "右の パネルで みんなに 公開しよう";
translations["MSG_BUILDER_TUTORIAL_SKIP"] = "後で見る";
translations["MSG_BUILDER_TUTORIAL_NEXT"] = "次へ";
translations["MSG_BUILDER_TUTORIAL_DONE"] = "はじめる";
translations["MSG_BUILDER_HELP_BTN"] = "ヘルプ";
// ピースビルダー: PiecePreview（spec §5.7）
translations["MSG_BUILDER_PREVIEW_RUN"] = "実行";
translations["MSG_BUILDER_PREVIEW_RESET"] = "リセット";
translations["MSG_BUILDER_PREVIEW_MOVES"] = "手数";
translations["MSG_BUILDER_PREVIEW_TIME"] = "タイム";
translations["MSG_BUILDER_PREVIEW_BLOCK_DISABLED"] = "この ピースでは 使えないよ";
translations["MSG_BUILDER_PREVIEW_CLEAR"] = "クリア！";
translations["MSG_BUILDER_PREVIEW_BACK"] = "戻る";
translations["MSG_BUILDER_SAVED"] = "保存ずみ";
translations["MSG_CHAT_NEW_BADGE"] = "New";
translations["MSG_CHAT_LOAD_MORE"] = "もっと見る";
translations["MSG_DASHBOARD_MAIL_EMPTY"] = "まだ郵便はありません";
translations["MSG_DASHBOARD_MAIL_IMAGE"] = "写真";
translations["MSG_DASHBOARD_MAIL_PROJECT"] = "プロジェクト";
translations["MSG_DASHBOARD_MAIL_COURSE_CLEAR"] = "コースクリア";

translations["MSG_CHAT_SEND_FAILED_MESSAGE"] = "メッセージの送信に失敗しました";

translations["MSG_CREATOR_DEFAULT_CHECK_APP"] = "アプリを\nチェック";
translations["MSG_CREATOR_DEFAULT_CREATE_APP"] = "アプリを作る";
translations["MSG_CREATOR_DEFAULT_SEARCH_APP"] = "アプリを探す";

translations["MSG_SUBSCRIPTION_ASK_PARENT_BTN"] = "おうちの人にお願いする";
translations["MSG_SUBSCRIPTION_ASK_PARENT_SENT_LABEL"] = "送信しました";
translations["MSG_SUBSCRIPTION_ASK_PARENT_MODAL_TITLE"] = "おうちの人にお願いする";
translations["MSG_SUBSCRIPTION_ASK_PARENT_MODAL_MESSAGE_WITH_PLAN"] =
  "「%{plan}」をおうちの人にお願いしますか？";
translations["MSG_SUBSCRIPTION_ASK_PARENT_MODAL_MESSAGE_NO_PLAN"] =
  "おうちの人にプランのお願いを送りますか？";
translations["MSG_SUBSCRIPTION_ASK_PARENT_SEND_BTN"] = "送る";
translations["MSG_SUBSCRIPTION_ASK_PARENT_CANCEL_BTN"] = "やめる";
translations["MSG_SUBSCRIPTION_ASK_PARENT_TOAST_SUCCESS"] = "お願いを送りました。";
translations["MSG_SUBSCRIPTION_ASK_PARENT_TOAST_ERROR"] =
  "送れませんでした。もう一度お試しください。";
translations["MSG_SUBSCRIPTION_REQUEST_CARD_CHILD_STATUS"] =
  "おうちの人にプランのお願いを送りました";

export default translations;
